import { en as leafletCreation } from '@/modules/leaflet-creation/messages'

export default {
  leafletCreation,
  shared: {
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    create: 'Create',
    update: 'Update',
    edit: 'Edit',
    save: 'Save',
    delete: 'Delete',
    warning: 'Warning',
    devices: {
      android: 'Android',
      androidMG: 'Moja Gazetka (Android)',
      androidMP: 'mPromocje (Android2)',
      iOS: 'iOS',
      ios: 'iOS',
      web: 'Web',
      wp: 'WP',
      all: 'Show on all platforms',
      android2: {
        'dev-1-pl': 'mPromocje',
        'dev-1-ua': 'Love Sales Light',
        'preprod-pl': 'mPromocje',
        'preprod-ua': 'Love Sales Light',
        'local': 'mPromocje',
        'pl': 'mPromocje',
        'ua': 'Love Sales Light'
      }
    },
    loading: 'Loading...',
    retry: 'Retry'
  },
  expand: 'Expand',
  collapse: 'Collapse',
  localeChanged: 'Switch language success',
  common: {
    update: 'Update',
    cancel: 'Cancel',
    confirm: 'Confirm',
    create: 'Create',
    delete: 'Delete',
    apply: 'Apply',
    copyToClipboard: 'Copy to clipboard',
    copiedToClipboard: 'Copied to clipboard',
    copyFailed: 'Failed to copy to clipboard',
    clickToViewDetails: 'Click to view details'
  },
  locationGroups: {
    manage: 'Location presets',
    title: 'Location presets — {store}',
    create: 'Create preset',
    empty: 'No presets',
    fields: { name: 'Name', available: 'Available locations', unavailable: 'Excluded locations' },
    availableCount: 'Available: {count}',
    unavailableCount: 'Excluded: {count}',
    editAria: 'Edit preset {name}',
    deleteAria: 'Delete preset {name}',
    deleteConfirm: 'Delete preset “{name}”?',
    validation: {
      name: 'Enter a preset name',
      invalidLocations: 'Fix invalid locations',
      locationsRequired: 'Add at least one location'
    },
    notice: { saved: 'Saved', savedReloadFailed: 'Saved, refresh failed' },
    errors: {
      duplicateName: 'A preset with this name already exists',
      exists: 'Preset already exists',
      notFound: 'Preset not found',
      invalid: 'Invalid preset data',
      unauthorized: 'Session expired',
      forbidden: 'Access denied',
      server: 'Server error',
      network: 'Network error',
      unexpectedStatus: 'Unexpected server response',
      unknown: 'The operation failed',
      load: 'Could not load presets'
    },
    selector: {
      placeholder: 'Select a preset',
      apply: 'Apply',
      confirmReplace: 'Replace the leaflet’s current locations?'
    },
    saveAs: { label: 'Save as location preset', action: 'Save' }
  },
  notification: {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    priorityUnavailable: 'There already is a leaflet for {os} with position {priorityNumber} (id: {naturalId})',
    failedToProcessFile:
      'Failed to process some of the uploaded files. Make sure the files have proper extensions(single .pdf file or multiple .jpg/.png files)',
    unknownError: 'Unknown error occurred'
  },
  errorMessages: {
    unknownError: 'Unknown error.',
    leafletNotFound: 'Leaflet with inserted ID not found.',
    invalidSession: 'Session has expired. Log in again.'
  },
  route: {
    dashboard: 'Shops and leaflets',
    xmlOffers: 'Leaflets order',
    selectiveNotifications: 'Notifications',
    categories: 'Categories',
    productHits: 'Product hits',
    inserts: 'Inserts',
    users: 'Users',
    leaflets: 'Leaflets',
    groups: 'Groups',
    archives: 'Archives',
    leafletsArchive: 'Leaflets archive',
    leafletsAlternative: 'Leaflets archive',
    shopsArchive: 'Shops archive',
    shopsAlternative: 'Shops',
    notificationsArchive: 'Notifications archive',
    notificationsAlternative: 'Notifications',
    leafletDetails: 'Leaflet details archive',
    leafletAlternative: 'Leaflet details',
    insertsAlternative: 'Inserts',
    insertsArchive: 'Inserts archive',
    logs: 'Logs',
    pageDetails: 'Page Details',
    password: 'Change your password',
    cooksAndRecipes: 'Cooks and recipes',
    scrapper: 'Scrapper',
    scrapperNewLeafletsSearch: 'Search for new leaflets',
    scrapperNewLeafletsSearchAlternative: '',
    reels: 'Reels',
    appConfig: 'App Configuration',
    loyaltyCards: 'Loyalty Cards',
    slider: 'Slider',
    tradeDays: 'Trade Days',
    productCategories: 'Product categories'
  },
  loyaltyCards: {
    addCard: 'Add Card',
    editCard: 'Edit Card',
    deleteCard: 'Delete Card',
    cardId: 'Card ID',
    cardName: 'Card Name',
    store: 'Store',
    storeId: 'Store ID',
    legacyId: 'Legacy ID',
    color: 'Color',
    cardImages: 'Card Images',
    cardImage: 'Card Image',
    uploadImage: 'Upload Image',
    uploadImageHint: 'Drag and drop or click to upload',
    changeImage: 'Change',
    removeImage: 'Remove',
    isPopular: 'Popular',
    popular: 'Popular',
    edit: 'Edit',
    noCards: 'No loyalty cards found',
    selectCountry: 'Select Country',
    createSuccess: 'Loyalty card created successfully',
    updateSuccess: 'Loyalty card updated successfully',
    deleteSuccess: 'Loyalty card deleted successfully',
    deleteConfirm: 'Are you sure you want to delete this loyalty card?',
    errorFetching: 'Error fetching loyalty cards',
    placeholders: {
      cardId: 'Enter card ID (lowercase letters, numbers, and hyphens only)',
      cardName: 'Enter card name',
      selectStore: 'Select store',
      selectColor: 'Select color'
    },
    validation: {
      cardIdRequired: 'Card ID is required',
      cardIdMinLength: 'Card ID must be at least 2 characters long',
      cardIdMaxLength: 'Card ID must be at most 50 characters long',
      cardIdInvalidFormat: 'Card ID can only contain lowercase letters, numbers, and hyphens',
      cardNameRequired: 'Card name is required',
      cardNameMinLength: 'Card name must be at least 2 characters long',
      cardNameMaxLength: 'Card name must be at most 50 characters long',
      colorRequired: 'Color selection is required',
      imageRequired: 'Card image is required',
      imageInvalidType: 'Please upload a valid image file'
    },
    errorCreating: 'Error creating loyalty card',
    errorUpdating: 'Error updating loyalty card',
    errorDeleting: 'Error deleting loyalty card'
  },
  appConfig: {
    title: 'Remote Configuration',
    subtitle: 'Manage remote configurations for mobile and web applications',
    platforms: {
      all: 'All Platforms',
      ios: 'iOS',
      android: 'Android',
      web: 'Web'
    },
    accordions: {
      articles: 'Articles - List Configuration',
      articlesSection: 'Articles -  Section Settings',
      mobileWhatsNewBanner: "Mobile What's New Banner",
      searchSettings: 'Search Settings',
      keywords: 'Keywords Management',
      mobileRecommendationType: 'Recommendation - Type',
      mobileRecommendationHighlightedLeafletId: 'Recommendation - Highlighted Leaflet ID',
      mobileRecommendationCustomTypeLink: 'Recommendation - Custom Type Link',
      mobileRecommendationCustomTypePictureUrl: 'Recommendation - Custom Type Picture URL',
      mobileOnboarding: 'Mobile Onboarding Stores',
      webPopularCities: 'Web - Popular Cities',
      webLeafletView: 'Web - Leaflet View',
      webPopularStores: 'Web - Popular Stores',
      webMegaMenu: 'Web - Mega Menu',
      webFooterLinks: 'Web - Footer Links',
      webRecipes: 'Web - Recipes',
      aiConfiguration: 'AI Configuration',
      roboflow: 'Roboflow Synchronization'
    },
    articlesSectionSettings: {
      title: 'Articles Section Settings',
      subtitle: 'Configure the settings for article sections in the application',
      noConfig: 'No configuration to display',
      noValue: 'No value',
      addSection: 'Add section',
      iconUrl: 'Icon URL',
      useBigSize: 'Use Big Size',
      position: 'Position',
      saveChanges: 'Save changes',
      saveError: 'Error while saving',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch section settings',
      tryAgain: 'Try again',
      validation: {
        titleRequired: 'Title is required',
        titleMinLength: 'Title must be at least 3 characters long',
        iconUrlRequired: 'Icon URL is required',
        iconUrlInvalid: 'Icon URL must be a valid URL',
        positionRequired: 'Position is required',
        positionInvalid: 'Position must be a valid integer'
      }
    },
    webPopularCities: {
      sectionTitle: 'Web Popular Cities',
      subtitle: 'Configure popular cities displayed in the web application',
      citiesConfig: 'Cities Configuration',
      dragHint: 'Drag to reorder cities',
      city: 'City',
      addCity: 'Add City',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Cities configuration saved successfully',
      saveError: 'Error saving cities configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch popular cities configuration',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        cityRequired: 'City name is required',
        cityMinLength: 'City name must be at least 1 character long'
      }
    },
    webLeafletView: {
      sectionTitle: 'Web Leaflet View',
      subtitle: 'Configure leaflet view settings for the web application',
      adsOnPageConfig: 'Ads Per Page Configuration',
      adsOnPage: 'Ads Per Page',
      addAdsOnPage: 'Add Ads Per Page Option',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Leaflet view configuration saved successfully',
      saveError: 'Error saving leaflet view configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch leaflet view configuration',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        adsOnPageRequired: 'Ads per page value is required',
        adsOnPagePositive: 'Ads per page value must be a positive number',
        adsOnPageMinLength: 'At least one ads per page option is required'
      }
    },
    webPopularStores: {
      sectionTitle: 'Web Popular Stores',
      subtitle: 'Configure popular stores displayed in the web application',
      storesConfig: 'Stores Configuration',
      selectStores: 'Select Stores',
      selectStoresPlaceholder: 'Select stores to display',
      selectedStores: 'Selected Stores',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Stores configuration saved successfully',
      saveError: 'Error saving stores configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch popular stores configuration',
      storesLoadingError: 'Error loading stores',
      storesLoadingErrorDesc: 'Failed to fetch stores list',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        storeIdRequired: 'Store ID is required',
        storeIdMinLength: 'Store ID must be at least 1 character long',
        storesMinLength: 'At least one store must be selected'
      }
    },
    webMegaMenu: {
      sectionTitle: 'Web Mega Menu',
      subtitle: 'Configure mega menu for the web application',
      storeCategories: 'Store Categories',
      categoryName: 'Category Name',
      selectStores: 'Select Stores',
      selectStoresPlaceholder: 'Select stores for this category',
      selectedStores: 'Selected Stores',
      addCategory: 'Add Category',
      recipesConfig: 'Recipes Configuration',
      selectCooks: 'Select Cooks',
      selectCooksPlaceholder: 'Select cooks to display',
      selectedCooks: 'Selected Cooks',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Mega menu configuration saved successfully',
      saveError: 'Error saving mega menu configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch mega menu configuration',
      storesLoadingError: 'Error loading stores',
      storesLoadingErrorDesc: 'Failed to fetch stores list',
      cooksLoadingError: 'Error loading cooks',
      cooksLoadingErrorDesc: 'Failed to fetch cooks list',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        categoryNameRequired: 'Category name is required',
        categoryNameMinLength: 'Category name must be at least 1 character long',
        storeIdRequired: 'Store ID is required',
        storeIdMinLength: 'Store ID must be at least 1 character long',
        storesMinLength: 'At least one store must be selected',
        cookIdRequired: 'Cook ID is required',
        cookIdMinLength: 'Cook ID must be at least 1 character long'
      }
    },
    webFooterLinks: {
      sectionTitle: 'Web Footer Links',
      subtitle: 'Configure footer links for the web application',
      storesPopular: 'Popular Stores',
      locationsPopular: 'Popular Locations',
      articlesPopular: 'Popular Articles',
      dragHint: 'Drag to reorder links',
      linkName: 'Link Name',
      linkUrl: 'Link URL',
      addLink: 'Add Link',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Footer links configuration saved successfully',
      saveError: 'Error saving footer links configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch footer links configuration',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        nameRequired: 'Link name is required',
        nameMinLength: 'Link name must be at least 1 character long',
        urlRequired: 'Link URL is required',
        urlMinLength: 'Link URL must be at least 1 character long'
      }
    },
    webRecipes: {
      sectionTitle: 'Web Recipes',
      subtitle: 'Configure recipes for the web application',
      promotedRecipes: 'Promoted Recipes',
      selectRecipes: 'Select Recipes',
      selectRecipesPlaceholder: 'Select recipes to promote',
      selectedRecipes: 'Selected Recipes',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset Changes',
      saveSuccess: 'Recipes configuration saved successfully',
      saveError: 'Error saving recipes configuration',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch recipes configuration',
      recipesLoadingError: 'Error loading recipes',
      recipesLoadingErrorDesc: 'Failed to fetch recipes list',
      tryAgain: 'Try again',
      validationErrors: 'Validation Errors',
      validation: {
        recipeIdRequired: 'Recipe ID is required',
        recipeIdMinLength: 'Recipe ID must be at least 1 character long'
      }
    },
    mobileWhatsNewBanner: {
      sectionTitle: "Mobile What's New Banner",
      subtitle: "Configure the what's new banner displayed in mobile applications",
      noConfig: 'No configuration to display',
      noValue: 'No value',
      addBanner: 'Add banner',
      clearBanner: 'Clear banner',
      bannerConfig: 'Banner Configuration',
      id: 'ID',
      title: 'Title',
      message: 'Message',
      deeplink: 'Deeplink',
      badge: 'Badge',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch banner settings',
      tryAgain: 'Try again',
      validation: {
        idMinLength: 'ID must be at least 3 characters long',
        titleMinLength: 'Title must be at least 3 characters long',
        messageMinLength: 'Message must be at least 3 characters long',
        deeplinkMinLength: 'Deeplink must be at least 3 characters long',
        badgeMinLength: 'Badge must be at least 3 characters long'
      }
    },
    searchSettings: {
      sectionTitle: 'Search Settings',
      subtitle: 'Configure search settings for mobile applications',
      noConfig: 'No configuration to display',
      noValue: 'No value',
      addSettings: 'Add settings',
      clearSettings: 'Clear settings',
      settingsConfig: 'Search Settings Configuration',
      includeAdBanner: 'Include Ad Banner',
      searchTip: 'Search Tip',
      popularWords: 'Popular Words',
      addWord: 'Add word',
      includePopularStores: 'Include Popular Stores',
      popularStores: 'Popular Stores',
      addStore: 'Add store',
      includePopularLeaflets: 'Include Popular Leaflets',
      popularLeaflets: 'Popular Leaflets',
      addLeaflet: 'Add leaflet',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      validation: {
        searchTipRequired: 'Search tip must not be empty'
      },
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch search settings',
      tryAgain: 'Try again'
    },
    keywords: {
      sectionTitle: 'Keywords Management',
      subtitle: 'Manage keywords used throughout the application',
      add: 'Add',
      addQueryAction: 'Add "{query}"',
      existingKeywords: 'Existing Keywords',
      totalCount: 'Total: {count} keywords',
      filteredCount: 'Showing: {count}',
      managementPlaceholder: 'Search keywords or add a new one...',
      noKeywordsYet: 'No keywords yet',
      noKeywordsYetAddable: 'No keywords yet. "{query}" can be added as the first keyword.',
      noFilteredKeywords: 'No keywords match your search',
      removeKeywords: 'Remove Keywords',
      removePlaceholder: 'Select keywords to remove...',
      removeHint: 'Select one or more keywords from the list to remove them, or click the × on any keyword tag above.',
      remove: 'Remove',
      cancel: 'Cancel',
      removeConfirm: 'Are you sure you want to remove {count} keyword(s)?',
      removeConfirmSingle: 'Are you sure you want to remove this keyword?',
      removeConfirmMultiple: 'Are you sure you want to remove {count} keywords?',
      removeTitle: 'Remove Keywords',
      updateSuccess: 'Keywords updated successfully',
      updateError: 'Error updating keywords',
      error: 'Error',
      validationErrors: 'Validation errors'
    },
    mobileRecommendationType: {
      sectionTitle: 'Mobile Recommendation Type',
      subtitle: 'Configure recommendation types for mobile applications',
      noConfig: 'No configuration to display',
      noValue: 'No value',
      addRecommendationType: 'Add recommendation type',
      clearRecommendationType: 'Clear recommendation type',
      recommendationConfig: 'Recommendation Type Configuration',
      value: 'Recommendation Type',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      validation: {
        valueRequired: 'Please select a recommendation type',
        invalidValue: 'Please select a valid recommendation type',
        pictureUrlRequired:
          'You must set a picture URL before using Image with Link type. Please go to Custom Type Picture URL section and set a valid URL first.',
        linkRequired:
          'You must set a link before using Image with Link type. Please go to Custom Type Link section and set a valid link first.'
      },
      options: {
        singleLeaflet: 'Single Leaflet',
        fourLeaflets: 'Four Leaflets',
        leafletsAndStores: 'Leaflets and Stores',
        leafletsStoreRating: 'Leaflets Store Rating',
        twoLeafletsThreeStoresRating: 'Two Leaflets Three Stores Rating',
        twoLeafletsFavouriteRating: 'Two Leaflets Favourite Rating',
        twoLeafletsFavouriteThreeStores: 'Two Leaflets Favourite Three Stores',
        imageWithLink: 'Image with Link'
      },
      untitled: 'Untitled',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch recommendation type settings',
      tryAgain: 'Try again'
    },
    mobileRecommendationHighlightedLeafletId: {
      sectionTitle: 'Highlighted Leaflet ID',
      subtitle: 'Configure the highlighted leaflet ID for mobile applications',
      noConfig: 'No configuration to display',
      highlightedLeafletConfig: 'Highlighted Leaflet ID Configuration',
      value: 'Leaflet ID',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch highlighted leaflet ID settings',
      tryAgain: 'Try again'
    },
    mobileRecommendationCustomTypeLink: {
      sectionTitle: 'Custom Type Link',
      subtitle: 'Configure the custom type link for mobile applications',
      disclaimer: 'Important:',
      disclaimerText: 'This configuration applies only when recommendation type is set to "Image with Link" (type 7).',
      noConfig: 'No configuration to display',
      customTypeLinkConfig: 'Custom Type Link Configuration',
      value: 'Link Value',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch custom type link settings',
      tryAgain: 'Try again'
    },
    mobileRecommendationCustomTypePictureUrl: {
      sectionTitle: 'Custom Type Picture URL',
      subtitle: 'Configure the custom type picture URL for mobile applications',
      disclaimer: 'Important:',
      disclaimerText: 'This configuration applies only when recommendation type is set to "Image with Link" (type 7).',
      noConfig: 'No configuration to display',
      customTypePictureUrlConfig: 'Custom Type Picture URL Configuration',
      value: 'Picture URL',
      preview: 'Preview',
      imageLoadError: 'Failed to load image. Please check the URL.',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      validationErrors: 'Validation errors',
      saveSuccess: 'Configuration saved successfully',
      loadingError: 'Error loading data',
      validation: {
        urlInvalid: 'URL must be valid'
      },
      loadingErrorDesc: 'Failed to fetch custom type picture URL settings',
      tryAgain: 'Try again',
      uploadImage: 'Upload image',
      imageUploadSuccess: 'Image uploaded successfully',
      imageUploadError: 'Error uploading image'
    },
    mobileOnboarding: {
      title: 'Mobile Onboarding Stores',
      description: 'Configure the list of stores shown during mobile app onboarding',
      loadingError: 'Error loading configuration',
      loadingErrorDesc: 'There was an error loading the configuration. Please try again.',
      tryAgain: 'Try Again',
      saveSuccess: 'Configuration saved successfully',
      saveError: 'Error saving configuration',
      validation: {
        storeIdRequired: 'Store ID is required'
      },
      storesLabel: 'Stores for onboarding',
      storesPlaceholder: 'Select or enter store IDs',
      storesHelpText: 'These stores will be shown to users during the onboarding process in the mobile app',
      saveButton: 'Save'
    },
    form: {
      platformLabel: 'Select platform'
    },
    articlesList: {
      title: 'Articles List Configuration',
      subtitle: 'Here you can configure the settings for displaying articles in the application',
      noConfig: 'No configuration to display',
      noValue: 'No value',
      addArticles: 'Add articles',
      article: 'Article',
      dragHint: 'Drag to reorder articles',
      additionalInfo: 'Additional information',
      imageUrl: 'Image URL',
      articleUrl: 'Article URL',
      isSponsored: 'Sponsored',
      addArticle: 'Add article',
      addArticleAtBeginning: 'Add article at the beginning',
      addArticleAtEnd: 'Add article at the end',
      saveChanges: 'Save changes',
      resetChanges: 'Reset changes',
      saveError: 'Error while saving',
      saveSuccess: 'Configuration saved successfully',
      copySuccess: 'Configuration copied successfully',
      copyError: 'Error while copying configuration',
      configDifference: 'Configuration differences detected',
      validation: {
        titleRequired: 'Title is required',
        titleMinLength: 'Title must be at least 3 characters long',
        additionalInfoRequired: 'Additional information is required',
        imageUrlRequired: 'Image URL is required',
        imageUrlInvalid: 'Image URL must be a valid URL',
        articleUrlRequired: 'Article URL is required',
        articleUrlInvalid: 'Article URL must be a valid URL'
      },
      configDifferenceDescription:
        'Android and iOS configurations are different. You can copy Android configuration to iOS.',
      copyToIos: 'Copy to iOS',
      allArticlesRemoved: 'All articles have been removed',
      articlesCount: '{count} article(s)',
      loadingError: 'Error loading data',
      loadingErrorDesc: 'Failed to fetch articles list',
      tryAgain: 'Try again',
      uploadImage: 'Upload image',
      imageUploadSuccess: 'Image uploaded successfully',
      imageUploadError: 'Error uploading image',
      basic: 'BASIC'
    },
    aiConfiguration: {
      sectionTitle: 'AI Configuration',
      subtitle: 'Configure AI settings for offer recognition processing',
      noConfig: 'No AI configuration exists for this country',
      createConfig: 'Create Configuration',
      provider: 'AI Provider',
      selectProvider: 'Select an AI provider',
      model: 'AI Model',
      selectModel: 'Select an AI model',
      prompt: 'Prompt',
      promptPlaceholder: 'Enter the AI prompt for offer recognition...',
      promptHint:
        'This prompt will be sent to the AI model to guide offer recognition. Be specific about the expected output format.',
      pagePrompt: 'Page Prompt (optional)',
      pagePromptPlaceholder: 'Enter the prompt for extracting offer validity dates from a leaflet page...',
      pagePromptHint:
        'Instructions for reading dates from the full leaflet page. An empty field saves an empty prompt.',
      currency: 'Offer Currency (optional)',
      currencyPlaceholder: 'Currency code, e.g. PLN',
      currencyHint:
        'Enter a three-letter currency code. It will be saved in uppercase. When editing, an empty field keeps the existing currency.',
      units: 'Measurement Units',
      addUnit: 'Add Unit',
      unitsHint: 'Units used for product measurements (e.g., kg, g, l, ml, pcs)',
      suggestedUnits: 'Suggested',
      metadata: 'Configuration Metadata',
      country: 'Country',
      createdDate: 'Created',
      lastModified: 'Last Modified',
      create: 'Create Configuration',
      saveChanges: 'Save Changes',
      resetChanges: 'Reset',
      saveSuccess: 'AI configuration saved successfully',
      saveError: 'Error saving AI configuration',
      saveFailed: 'Failed to save configuration. Please try again.',
      invalidData: 'Invalid configuration data',
      noPermission: 'You do not have permission to modify this configuration',
      validationError: 'Please fix the validation errors',
      validationErrors: 'Validation errors',
      loadingError: 'Error loading AI configuration',
      loadingErrorDesc: 'Failed to fetch AI configuration',
      tryAgain: 'Try Again',
      validation: {
        providerRequired: 'Provider is required',
        providerInvalid: 'Provider must be OPENAI, GOOGLE or DEEPSEEK',
        currencyInvalid: 'Currency code must contain exactly three letters',
        modelRequired: 'Model is required',
        modelInvalid: 'Model must contain only letters, numbers, hyphens, and dots',
        promptMinLength: 'Prompt must be at least 10 characters',
        unitInvalid: 'Units must contain only alphanumeric characters'
      }
    },
    roboflow: {
      sectionTitle: 'Roboflow Synchronization',
      subtitle: 'Send queued leaflet pages to the Roboflow training dataset.',
      maxImagesNumber: 'Maximum number of images',
      maxImagesNumberHint: 'Sets the maximum number of queued images sent by this operation.',
      store: 'Store (optional)',
      allStores: 'All stores',
      storeHint: 'Leave empty to synchronize images without filtering by store.',
      storesLoadingError: 'The store list could not be loaded. You can still synchronize all stores.',
      synchronize: 'Start synchronization',
      confirmTitle: 'Start Roboflow synchronization?',
      confirmMessage: 'Up to {count} images will be selected for sending. Store: {store}.',
      synchronizeSuccess: 'Synchronization of queued images has started.',
      synchronizeError: 'Roboflow synchronization could not be started.',
      validation: {
        maxImagesNumber: 'The number of images must be a positive integer.'
      }
    }
  },
  selectiveNotifications: {
    addNotification: 'Add notification',
    notificationId: 'Notification Id',
    plannedTime: 'Planned time',
    channel: 'Channel',
    title: 'Title',
    devices: 'Platforms',
    saveSuccess: 'Notification saved successfully',
    deleteSuccess: 'Notification removed successfully',
    deleteConfirm: 'Are you sure you want to remove this notification?'
  },
  dashboard: {
    title: 'Stores and leaflets',
    preventCloseTab: 'Do you really want to leave? You will lost unsaved changes!',
    nothing: 'Nothing',
    missingLeafletForStore: 'Missing leaflets',
    actions: 'Actions',
    publicationPlanned: 'Publication planned',
    leafletProcessing: {
      pending: 'Waiting for processing',
      processing: 'Processing leaflet...',
      failed: 'Processing failed',
      failedHint: 'Could not generate leaflet images. Open the leaflet and try again.'
    },
    search: {
      placeholder: 'Search store, leaflet ID or leaflet name'
    },
    storesWithoutLeaflets: {
      title: 'Stores without leaflets'
    },
    productsToCheck: {
      title: 'Products to check'
    },
    xml: {
      button: 'Publish changes',
      confirm: 'Do you really want to publish leaflets?',
      success: 'Leaflets published successfully',
      successWithNotifications: 'Leaflets published successfully.\nNotifications generated successfully for: ',
      allPlatforms: 'All platforms',
      inProgress: 'Leaflets are being published. We will notify you when the publication process is complete.',
      inProgressWithNotification:
        'Leaflets are being published. We will notify you when the publication process is complete and notifications will be send.',
      generateNotificationsInProgress:
        'Notifications are being generated. We will notify you when the publication process is complete.',
      lastGenerated: 'Last published changes',
      generatedBy: 'by'
    },
    xmlAndNotifications: {
      button: 'Publish leaflets and generate notifications',
      confirm: 'Do you really want to publish leaflets and generate notifications?'
    },
    activation: {
      success: 'Leaflet is ready for activation.'
    },
    cutRequest: {
      request: 'Cut',
      retry: 'Retry',
      cutAgain: 'Cut again',
      rerun: 'Rerun cut',
      rerunConfirmTitle: 'Rerun cut?',
      rerunConfirmMessage:
        'Rerunning the cut will process the whole leaflet again and may replace current offers and manual edits.',
      rerunConfirmConfirm: 'Rerun cut',
      success: 'Cut request sent successfully',
      error: 'Error during cut request',
      featureDisabled: 'Offers recognition feature is disabled'
    },
    cutStatus: {
      checking: 'Checking status...',
      processing: 'Processing',
      pending: '{count} pages in progress',
      complete: 'Cut',
      toFix: 'To fix ({count})',
      failed: 'Cut failed ({count} pages) - Retry',
      error: 'Failed to check status - Retry'
    },
    leafletStatus: {
      successPages: 'Cut:',
      errorPages: 'Not cut:',
      pendingPages: 'In progress:',
      pageTooltip: 'Page {pageNumber}: {status}',
      statusText: {
        SUCCESS: 'Cut successfully',
        FAILED: 'Error',
        IN_PROGRESS: 'In progress'
      }
    },
    notifications: {
      button: 'Generate notifications',
      buttonSelect: 'Selective notifications',
      confirm: 'Do you really want to generate notifications?',
      success: 'Notifications generated successfully for:',
      successNoStores: 'Notifications have not been sent. No new leaflets.',
      selectedShopsTitle: 'Generate notifications for selected stores',
      selectedShopsTitleEdit: 'Edit notification',
      selectAll: 'Select all shops',
      selectAllGroups: 'Select all groups',
      selectShops: 'Select shops',
      selectGroups: 'Select groups',
      form: {
        id: 'Notification ID:',
        titleLabel: 'Title:',
        titlePlaceholder: 'Insert title',
        textLabel: 'Message:',
        channel: 'Channel',
        bigIcon: 'Big icon URL',
        bigPicture: 'Big picture URL',
        uploadImage: 'Select image',
        deepLink: 'Deep link',
        webpageLink: 'Webpage link',
        showTrackingLink: 'Show tracking link',
        openTrackingLink: 'Open tracking link',
        geoLocations: 'Geolocations',
        selectedShops: 'Shops',
        selectedGroups: 'Groups',
        devices: 'Send to',
        specialOffer: {
          description: 'Special offer',
          details: 'Ignores favorite stores settings'
        },
        errors: {
          titleRequiredForChannels:
            'Notification title is required if channel is different than NEW_OFFERS_NOTIFICATION',
          invalidGeolocationsFormat:
            'Invalid geolocation format. There should be 3 elements in one line separated by comma',
          invalidLatitudeValue: 'Latitude should be between -90.0000000 and 90.0000000',
          invalidLongitudeValue: 'Longitude should be between -180.0000000 and 180.0000000',
          invalidRadiusValue: 'Radius should be a positive number',
          invalidUrlValue: 'Invalid URL',
          newOffersNotificationSet: 'Value must be empty if channel is set to NEW_OFFERS_NOTIFICATION',
          shopsRequired: 'At least one shop or group must be selected',
          devicesRequired: 'At least one platform is required'
        }
      }
    },
    planNotifications: {
      title: 'Plan notification',
      dateLabel: 'for day',
      hourLabel: 'for hour',
      saveLabel: 'Schedule',
      successMessage: 'Notification is scheduled'
    },
    articlesData: {
      unmatchedData: 'Unmatched leaflests',
      noUnmatchedData: 'There are no mismatched leaflets.',
      restoreArticles: 'Restore deleted leaflets',
      restoreArticlesSuccess: 'Leaflet successfully restored',
      restoreArticlesInfo:
        'Restores the deleted leaflets to IMPORTED status. Only actual (valid) leaflets can be restored.',
      noLeafletsToRestore: 'There are no leaflets to restore.',
      removeConfirm: 'Are you sure you want to remove this leaflet?',
      status: 'status: ',
      importInProgress: 'Import in progress',
      close: 'Close'
    },
    leaflets: {
      fetching: 'Fetching leaflets...',
      sorting: 'Sorting leaflets...',
      shopsUpdate:
        'Shops data are updating in background. The content of the page may be diffrent than data on the server',
      leafletsUpdate:
        'Leaflets data are updating in the background. The content of the page may be diffrent than data on the server',
      fetch: {
        error: {
          title: 'Error loading leaflets',
          description: 'Failed to fetch leaflet data. Please try again.'
        },
        partialError: {
          title: 'Some leaflets could not be loaded',
          description: 'Some leaflets failed to load, but others are displayed below.'
        }
      },
      empty: {
        description: 'No leaflets to display'
      },
      pageCount: 'Pages'
    },
    stores: {
      publishDate: 'Publish date',
      publishEndDate: 'Publish until',
      naturalId: 'Natural ID',
      seoId: 'Seo ID',
      identifiers: 'Natural ID / SEO ID',
      additionalInfo: 'Additional Info',
      rejectModal: 'Are you sure you want to reject this leaflet?',
      valid: 'Date',
      platforms: 'Platforms',
      validFromPrefix: 'from',
      validToPrefix: 'to',
      status: 'Status',
      validFrom: 'Valid from',
      validFromPlaceholder: 'Select valid from date',
      validTo: 'Valid to',
      validToPlaceholder: 'Select valid to date',
      actions: 'Actions',
      remove: 'Remove',
      update: 'Edit',
      assign: 'Assign',
      resotre: 'Restore',
      showOn: 'Shown on',
      articles: 'Products',
      expandAllStores: 'Expand all stores',
      shrinkAllStores: 'Shrink all stores'
    },
    syncLongUrl: {
      button: 'Sync Links',
      title: 'Links Synchronization',
      submit: 'Synchronize',
      newSync: 'New Synchronization',
      processing: 'Processing...',
      processingHint: 'Synchronization may take up to a minute. Please wait.',
      runDryRun: 'Run Dry Run',
      dryRunComplete: 'Dry Run Complete',
      syncComplete: 'Sync Complete',
      proceedWithSync: 'Proceed with Sync',
      rerunDryRun: 'Rerun Dry Run',
      rerunWithSameSettings: 'Rerun with Same Settings',
      backToForm: 'Back to Form',
      form: {
        sheetUrl: 'Google Sheet URL',
        sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
        syncScope: 'Sync Scope',
        syncAll: 'Sync All',
        syncByLeaflet: 'Sync by Leaflet Natural ID',
        leafletNaturalId: 'Leaflet Natural ID',
        leafletPlaceholder: 'Search for leaflet...',
        syncStatus: 'Sync Status',
        dryRun: 'Dry Run Mode',
        dryRunHint: 'Simulate without making changes',
        override: 'Override Existing Data',
        overrideHint: 'Force overwrite existing data during synchronization'
      },
      syncStatus: {
        readyToSync: 'READY_TO_SYNC',
        empty: 'No filter (empty)',
        pending: 'PENDING',
        processed: 'PROCESSED',
        failed: 'FAILED',
        invalid: 'INVALID',
        unprocessable: 'UNPROCESSABLE'
      },
      validation: {
        sheetUrlRequired: 'Google Sheet URL is required',
        sheetUrlInvalid: 'Please enter a valid Google Sheets URL',
        leafletRequired: 'Leaflet Natural ID is required'
      },
      errors: {
        syncFailed: 'Synchronization failed'
      },
      result: {
        title: 'Synchronization Complete',
        sheetUrl: 'Google Sheet',
        totalRows: 'Total Rows',
        processed: 'Processed',
        failed: 'Failed',
        unprocessable: 'Unprocessable',
        postponed: 'Postponed',
        superseded: 'Superseded',
        expired: 'Expired',
        rowIndex: 'Row',
        leafletId: 'Leaflet ID',
        type: 'Type',
        page: 'Page',
        message: 'Message',
        reason: 'Reason'
      }
    }
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    screenfull: 'Screenfull',
    theme: 'Theme',
    password: 'Change password',
    archives: 'Archives',
    inserts: 'Inserts',
    logs: 'Logs',
    xmlOffers: 'Leaflets order',
    leaflets: 'Leaflets',
    version: 'version'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password'
  },
  theme: {
    change: 'Theme change'
  },
  users: {
    expandedRow: {
      cooks: 'COOKS: ',
      stores: 'SHOPS: '
    },
    enable: {
      button: 'Enable',
      success: 'Status changed successfully'
    },
    disable: {
      button: 'Disable',
      success: 'Status changed successfully'
    },
    fetchData: 'Fetching data..',
    id: 'ID',
    role: 'Role',
    actions: 'Actions',
    username: 'Username',
    enabled: 'Enabled',
    disabled: 'Disabled',
    availableShops: 'Available shops',
    assignedShops: 'Assigned shops',
    availableCooks: 'Available cooks',
    assignedCooks: 'Assigned cooks',
    availableReelChannels: 'Available channels',
    assignedReelChannels: 'Assigned channels',
    availablePolicies: 'Available policies',
    assignedPolicies: 'Assigned policies',
    stores: 'Stores',
    cooks: 'Cooks',
    assignAlertForAdmins:
      'The administrator has access to all shops, chefs and reel channels. Access management is unnecessary.',
    update: {
      title: 'Edit user',
      button: 'Update',
      success: 'User has been updated',
      error: 'User has not been updated'
    },
    create: {
      title: 'Create user',
      username: 'Username',
      password: 'Password',
      cancel: 'Cancel',
      button: 'Create user',
      success: 'User created successfully',
      role: 'Role',
      stores: 'Stores',
      pickRole: 'Pick a role',
      shopFilterPlaceholder: 'Search for a shop',
      cooksFilterPlaceholder: 'Search for a cook',
      reelChannelsPlaceholder: 'Search for channel',
      policiesFilterPlaceholder: 'Search for policy',
      notificationChannels: 'Channels',
      reelChannels: 'Reels channels',
      productPanelPolicies: 'Product Panel Policies'
    },
    remove: {
      button: 'Delete',
      confirm: 'Do you really want to remove this user?',
      success: 'User removed successfully'
    },
    changePassword: {
      button: 'Zmień hasło',
      dialogTitle: 'Zmień hasło użytkownika {name}',
      success: 'Hasło zostało zmienione.'
    },
    rules: {
      username: 'User name is required and has to be longer than 3 characters',
      usernameLowercase: 'Username must not contain uppercase letters',
      role: 'Role is required',
      notificationChannels: 'At least one channel is required',
      policyIds: 'At least one policy is required for PRODUCTS_VIEWER role'
    },
    policyDetails: {
      title: 'Policy Details',
      brands: 'Brands',
      categories: 'Categories',
      countries: 'Countries',
      stores: 'Stores',
      all: 'All',
      close: 'Close'
    },
    policyManagement: {
      title: 'Manage Policies for Product Panel',
      manageButton: 'Manage Policies for Product Panel',
      createTitle: 'Create New Policy',
      editTitle: 'Edit Policy',
      createButton: 'Create Policy',
      editButton: 'Edit',
      deleteButton: 'Delete',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      nameLabel: 'Policy Name',
      namePlaceholder: 'Enter policy name',
      brandsLabel: 'Brands',
      brandsPlaceholder: 'Select or create brands',
      categoriesLabel: 'Categories',
      categoriesPlaceholder: 'Select categories',
      allCategories: 'All categories (*)',
      countriesLabel: 'Countries',
      countriesPlaceholder: 'Select countries',
      storesLabel: 'Stores',
      storesPlaceholder: 'Select or create stores',
      deleteConfirmTitle: 'Delete Policy',
      deleteConfirmMessage: 'Are you sure you want to delete this policy? This action cannot be undone.',
      deleteConfirmButton: 'Delete',
      createSuccess: 'Policy created successfully',
      updateSuccess: 'Policy updated successfully',
      deleteSuccess: 'Policy deleted successfully',
      saveError: 'Failed to save policy',
      deleteError: 'Failed to delete policy',
      deleteConflictError: 'Cannot delete policy. It is assigned to one or more users.',
      fetchError: 'Failed to fetch policies',
      validation: {
        nameRequired: 'Policy name is required',
        nameMinLength: 'Policy name must be at least 3 characters',
        nameMaxLength: 'Policy name must not exceed 255 characters',
        brandsRequired: 'At least one brand is required',
        categoriesRequired: 'At least one category is required',
        countriesRequired: 'At least one country is required',
        storesRequired: 'At least one store is required',
        validationFailed: 'Validation failed'
      },
      countries: {
        all: 'All (*)',
        pl: 'Poland (pl)',
        by: 'Belarus (by)',
        cz: 'Czech Republic (cz)',
        lt: 'Lithuania (lt)',
        ro: 'Romania (ro)',
        sk: 'Slovakia (sk)',
        ua: 'Ukraine (ua)'
      }
    },
    userCreate: {
      button: 'Add user',
      enabled: 'Enabled'
    }
  },
  groups: {
    tableLabel: {
      id: 'ID',
      name: 'Name',
      actions: 'Actions'
    },
    update: {
      button: 'Edit'
    },
    remove: {
      button: 'Delete',
      confirm: 'Do you really want to delete this group?',
      success: 'Group deleted successfully.'
    },
    addGroup: {
      title: 'Add new group',
      name: 'Name: ',
      cancelButton: 'Cancel',
      success: 'Group has been created.',
      button: 'Add group'
    },
    editGroup: {
      title: 'Edit group',
      button: 'Save changes',
      success: 'Group updated successfully.'
    },
    rules: {
      name: {
        required: 'Group name is required'
      }
    }
  },
  shops: {
    unmatchedLeaflets: 'Unmatched leaflets',
    fetchData: 'Loading shops..',
    id: 'ID',
    editors: 'Editors',
    available: 'Available',
    add: 'Add shop',
    update: 'Update',
    remove: {
      button: 'Remove',
      confirm: 'Do you really want to remove this shop?',
      success: 'Shop removed succesfully'
    },
    filterByInactive: 'Inactive only',
    activateAllLeaflets: 'Activate all leaflets',
    showShopLeaflets: 'Show leaflets',
    shrinkShopLeaflets: 'Shrink leaflets',
    shopCreate: {
      title: 'Create shop',
      cancel: 'Cancel',
      confirm: 'Add shop',
      name: 'Name',
      storeWebId: 'Id Name',
      update: 'Update shop',
      category: 'Category',
      pickCategory: 'Pick category',
      salesModels: {
        label: 'Sales model',
        placeholder: 'Select a sales model',
        options: {
          retail: 'Retail',
          wholesale: 'Wholesale'
        }
      },
      ownBrandIds: 'Own brand IDs',
      ownBrandIdsPlaceholder: 'Add own brand IDs',
      success: 'Shop created successfully',
      logos: {
        title: 'Shop logos',
        current: 'Current logo',
        light: {
          label: 'Light mode logo',
          upload: 'Drop a file here or click to add the light logo'
        },
        dark: {
          label: 'Dark mode logo (optional)',
          upload: 'Drop a file here or click to add the dark logo',
          fallback: 'If omitted, the application uses the light mode logo.'
        }
      },
      forceFavorites: {
        description: 'Favorites',
        details: 'Shop will be shown as a Favourite to every user'
      },
      showAnyway: {
        details: 'Show anyway despite hiding',
        description: 'If the user hides this store, it will still be displayed in the application'
      },
      storeAtFirst: {
        details: 'Show on the top of the list',
        description: 'Shop will be placed at the top of the list on the Stores page in the application'
      },
      addAsReelsChannel: {
        details: 'The store will be shown at the top of the app in reels',
        description: 'Ad as channel'
      },
      shouldAutoProcessLeaflets: {
        description: 'Automatic leaflet cutting',
        details: 'When the flag is checked, the leaflet will be automatically cut after being added'
      },
      editors: 'Choose who should have access to the store',
      rules: {
        geolocations: 'Each line must use the lat,lng,radius format. Convert addresses with the magic wand.',
        name: 'Name is required',
        storeWebId: 'Id Name is required',
        storeWebIdText: 'Name Id can only contain lowercase letters, numbers and "-" sign',
        storeNameDuplicate: 'The shop with the name {name} already exists',
        category: 'Category is required',
        salesModels: 'Select at least one sales model'
      }
    },
    deleteLinks: {
      selectPlaceholder: 'Select links to delete',
      confirm: 'Do you really want to delete links from this shop?',
      success: 'Links have been removed.'
    },
    shopUpdate: {
      title: 'Update shop',
      success: 'Shop updated successfully'
    }
  },
  password: {
    currentPassword: 'Current password',
    newPassword: 'New password',
    newPasswordRepeat: 'Repeat password',
    submitPassword: 'Change password',
    reset: 'Reset form',
    rules: {
      minLength: 'Password is required and has to be longer than {minLength} characters'
    }
  },
  leaflets: {
    addToSystem: 'Add to the system',
    dataSync: {
      message:
        'Leaflets data are updating in the background. The concent of the page may be different than data on the server.'
    },
    validation: {
      errorInLeafletId: 'in leaflet ID'
    },
    readyForActivation: 'Leaflets ready for publication',
    readyForDisactivation: 'Leaflets ready for removal',
    fetchData: 'Loading leaflets..',
    untilEndOfSupply: 'Until end of supply',
    naturalId: 'ID',
    validFrom: 'From',
    validTo: 'To',
    priority: 'Position',
    refresh: {
      button: 'Refresh leaflet',
      success: 'Date has been refreshed successfully',
      confirm: 'Do you really want to refresh leaflet?'
    },
    activateStatusDate: 'Activate date',
    additionalInfo: 'Info',
    additionalInfoMissing: '[no title]',
    additionalInfo2: 'Info 2',
    longUrl: 'URL',
    thumbnailTrackingUrl: 'Thumbnail tracking URL',
    thumbnailTrackingUrlConfirm: 'You added thumbnail tracking URL (not opening leaflets)',
    redirectUrl: 'Redirect URL',
    status: 'Status',
    actions: 'Actions',
    actionMenu: {
      edit: 'Edit leaflet',
      showInDashboard: 'Show in dashboard'
    },
    update: 'Update',
    add: 'Add leaflet',
    goToPageDetails: 'Redirects and inserts',
    activate: 'Activate',
    details: 'Details',
    publishDate: 'Publish date',
    createdBy: 'Published by',
    activateReadyStatusAt: 'Refresh date',
    refreshedBy: 'Refreshed by',
    products: {
      geolocation: {
        label: 'Geolocation',
        description: "Set the default geolocation settings will be used to add this store's leaflets.",
        options: {
          notGeolocalized: {
            description: 'Not geolocalized',
            details: 'Visible for any location'
          },
          geolocalizedDependingOnStore: {
            description: 'Geolocalized depending on store location',
            details: 'Visible in the vicinity of the store (address base - e.g. crawlers)'
          },
          geolocalizedDependingOnAreas: {
            description: 'Geolocalized depending on areas',
            details: 'Visible in the areas set'
          }
        },
        showToUserWithNoLocation: {
          description: 'Show to users without a location',
          details: 'The leaflet will also be visible to users who have not provided their location'
        },
        areas: {
          label: 'List of areas (lat/lng/rad)',
          description:
            'Enter each address or area on a new line. Use the magic wand to convert addresses. The radius is given in meters.',
          placeholder: 'Warsaw\n51.4141,16.55551,100'
        },
        availableAreas: {
          label: 'Display locations (lat/lng/rad)',
          description:
            'The leaflet will be visible in these areas. Enter each address or area on a new line. The radius is given in meters.',
          placeholder: 'Warsaw\n51.4141,16.55551,100'
        },
        unavailableAreas: {
          label: 'Excluded locations (lat/lng/rad)',
          description:
            'The leaflet will not be visible in these areas. Enter each address or area on a new line. The radius is given in meters.',
          placeholder: 'Cracow\n50.0647,19.945,500'
        },
        geocode: {
          tooltip: 'Convert addresses to coordinates',
          ariaLabel: 'Geocode entered addresses',
          success: 'Addresses converted: {count}',
          partialSuccess: 'Converted {converted} addresses. Not recognized: {failed}.',
          failure: 'Could not recognize addresses: {count}.'
        },
        map: {
          ariaLabel: 'Geolocation areas map preview',
          empty: 'The map will appear after entering coordinates or converting an address.',
          legend: {
            ariaLabel: 'Area availability legend',
            available: 'Show',
            unavailable: 'Hide'
          }
        }
      },
      button: 'Products',
      fetchError: 'Error fetching product data',
      count: 'products',
      nameLabel: 'Name',
      brandLabel: 'Brand',
      manufacturerLabel: 'Manufacturer',
      manufacturerSourceLabel: 'Information source',
      manufacturerSources: {
        printed: 'Leaflet',
        package: 'Packaging',
        knowledge: 'Knowledge'
      },
      variantLabel: 'Variant',
      packagingLabel: 'Packaging',
      packagingTypeLabel: 'Packaging type',
      packagingSubtypeLabel: 'Packaging subtype',
      packCountLabel: 'Pack count',
      unitSizeLabel: 'Unit size',
      coordsLabel: 'Coords',
      actions: 'Actions',
      edit: 'Edit',
      duplicate: 'Duplicate',
      addArticle: 'Add Article',
      createArticle: 'Create Article',
      updateArticle: 'Update Article',
      priceLabel: 'Price',
      currencyLabel: 'Currency',
      pricePerUnitLabel: 'Price per unit',
      pricePerUnitBasisLabel: 'Price per unit basis',
      unitLabel: 'Unit',
      crossedPriceLabel: 'Crossed price',
      discountLabel: 'Discount',
      lowestPrice30DaysLabel: 'Lowest price in 30 days',
      depositLabel: 'Deposit',
      multibuyLabel: 'Multibuy',
      multibuyTypeLabel: 'Multibuy type',
      multibuyTextLabel: 'Multibuy conditions',
      sizeOptionsLabel: 'Size options',
      specsTextLabel: 'Specifications',
      soldByLabel: 'Sold by',
      loyaltyProgramLabel: 'Loyalty program',
      conditionTextLabel: 'Offer conditions',
      minQtyLabel: 'Minimum quantity',
      limitLabel: 'Purchase limit',
      blockCountLabel: 'Promotion block count',
      reviewReasonsLabel: 'Review reasons',
      addSizeOption: 'Add size option',
      removeSizeOption: 'Remove size option',
      noSizeOptions: 'No size options',
      sections: {
        basic: 'Basic information',
        pricing: 'Pricing and promotion',
        packaging: 'Packaging and sale',
        conditions: 'Offer conditions',
        quality: 'Quality review'
      },
      keywordsLabel: 'Keywords',
      keywordsPlaceholder: 'Enter keyword',
      addKeyword: 'Add keyword',
      createKeywordConfirmTitle: 'Create new keyword',
      createKeywordConfirmMessage: 'Do you want to create the new keyword “{keyword}”?',
      createKeywordSuccess: 'The new keyword has been created',
      createKeywordError: 'Failed to create the new keyword',
      keywordsFetchError: 'Failed to fetch active keywords',
      invalidKeyword: 'A keyword must contain between 1 and 100 characters',
      multipleKeywordsUnsupported: 'Add new keywords one at a time',
      ownBrandLabel: 'Own Brand',
      promotedLabel: 'Promoted',
      flagEnabled: 'Yes',
      flagDisabled: 'No',
      categoriesLabel: 'Categories',
      categoriesPlaceholder: 'Select categories',
      categoriesRemovedOnSave: 'Saving the offer will remove inactive and unknown categories: {names}',
      createSuccess: 'Article created successfully',
      createError: 'Failed to create article',
      updateSuccess: 'Article updated successfully',
      updateError: 'Failed to update article',
      deleteSuccess: 'Article deleted successfully',
      deleteError: 'Failed to delete article',
      deleteConfirmTitle: 'Delete Article',
      deleteConfirmMessage: 'Are you sure you want to delete the article "{name}"? This action cannot be undone.',
      updateSelection: 'Update Selection',
      finishSelection: 'Finish Selection',
      drawingModeText: 'SELECTION MODE - Click and drag to select area',
      editArea: 'Edit Area',
      drawAreaInstructions: 'Click and drag to select an area on the image',
      areaUpdated: 'Area coordinates updated successfully',
      roboflow: {
        addToTraining: 'Send for training',
        addSuccess: 'Page {pageNumber} was added to the training data queue.',
        addError: 'The page could not be added to the training data queue.'
      },
      recutPage: {
        button: 'Rerun page cut',
        confirmTitle: 'Rerun page cut?',
        confirmMessage: 'Rerunning the cut for page {pageNumber} may replace its current products and manual edits.',
        confirmButton: 'Rerun page cut',
        success: 'The request to rerun the cut for page {pageNumber} was sent.',
        error: 'The cut for page {pageNumber} could not be rerun.'
      },
      validation: {
        manufacturerRequired: 'Enter a manufacturer for the selected source',
        manufacturerSourceRequired: 'Select the manufacturer information source',
        labelRequired: 'Name is required',
        areaRequired: 'Please select an area on the image before creating the article',
        validToBeforeValidFrom: 'Valid to date cannot be before valid from date',
        coordsRequired: 'Coordinates are required',
        pageNumberMin: 'Page number must be greater than 0',
        pageNumberInteger: 'Page number must be an integer',
        pageNumberRequired: 'Page number is required',
        dateRange: 'Valid from date cannot be later than valid to date',
        genericError: 'A validation error occurred'
      },
      mapPriceLabel: 'Map price',
      categoryLabel: 'Category',
      title: 'Article data'
    },
    remove: {
      button: 'Remove',
      confirm: 'Do you really want to remove this leaflet?',
      success: 'Leaflet removed successfully'
    },
    clipboard: {
      copyConfig: 'Copy configuration',
      pasteConfig: 'Paste configuration',
      copySuccess: 'Leaflet configuration copied',
      copyError: 'Failed to copy leaflet configuration',
      pasteSuccess: 'Leaflet configuration pasted',
      pasteError: 'Failed to paste leaflet configuration'
    },
    openPageDetailsImages: 'Preview pages',
    zipCodes: 'Zip codes',
    pageCount: 'Pages',
    statusList: {
      INACTIVE: 'Inactive',
      READY_FOR_ACTIVATION: 'Ready for activation',
      ACTIVE: 'Active',
      READY_FOR_DISACTIVATION: 'Ready for disactivation',
      DELETED: 'Deleted'
    },
    pageDetailsImages: {
      title: 'Preview pages images',
      pageNumber: 'Page number:',
      dimensions: 'Dimensions:',
      size: 'Size:'
    },
    organizePages: {
      title: 'Organize Pages',
      description: 'View and organize the pages of this leaflet. Pages are displayed in their current order.',
      downloadInfo:
        'To upload pages in a different order, download all images and then upload them in the "Upload new leaflet" tab.',
      pageNumber: 'Page {number}',
      pagePreview: 'Page {number} preview',
      noPages: 'No pages found for this leaflet',
      noLeafletId: 'No leaflet ID provided',
      fetchError: 'Failed to fetch page details',
      error: 'Error loading pages'
    },
    uploadWrapper: {
      uploadNewLeaflet: 'Upload new leaflet',
      organizePages: 'Organize pages'
    },
    rules: {
      naturalId: 'Unique name is required',
      validFrom: 'From date is required',
      validTo: 'From date is required',
      validToExpired: 'The expiry date has already passed. Make sure you enter the correct date.',
      validToBeforeValidFrom: 'Valid to date cannot be before valid from date',
      publishDateIsFromThePast: 'Publish date cannot be from the past',
      publishDate: 'Publishing date is required',
      active: 'Leaflet state is required',
      file: 'At least one file is required',
      priority: 'Position should be a natural number with max 3 digits',
      numberOfImages: 'Position should be a natural number',
      geolocations: 'Each line must use the lat,lng,radius format. Convert addresses with the magic wand.',
      socialMediaUrl: 'Please provide a valid URL',
      scheduledEventIncomplete: 'Scheduled replacement is incomplete'
    },
    uploadFiles: {
      select: 'Drop file here or click to upload',
      send: 'Upload',
      wrongFile: 'Wrong file type',
      tooManyPdfs: 'You can upload only one PDF file',
      wrongId: 'Do you really want to add pdf with Id Name different than',
      firstPage: 'Drop file here or click to change the cover',
      outdatedPdf:
        'The dates defined in the pdf file are in the past. Name the file correctly or enter the correct dates.'
    },
    leafletsCreate: {
      title: 'Create leaflet',
      crawlerTitle: 'Create leaflet draft',
      naturalId: 'ID',
      validFrom: {
        label: 'From',
        placeholder: 'Put date'
      },
      button: 'Create',
      group: 'Group',
      newGroup: 'New',
      additionalOptions: 'Additional options',
      hasRecipe: 'Has recipe',
      category: {
        label: 'Set category',
        placeholder: 'Default'
      },
      validTo: {
        label: 'To',
        placeholder: 'Put date',
        checkbox: 'Until end of supply'
      },
      publishDate: {
        label: 'Publication',
        placeholder: 'Pick date and time'
      },
      publishEndDate: {
        label: 'Publish until',
        placeholder: 'Pick date and time'
      },
      showOn: {
        label: 'Shown on',
        android: 'Android',
        androidMG: 'Moja Gazetka (Android)',
        androidMP: 'mPromocje (Android2)',
        iOS: 'iOS',
        ios: 'iOS',
        web: 'Web',
        wp: 'WP',
        all: 'Show on all platforms',
        android2: {
          'dev-1-pl': 'mPromocje',
          'dev-1-ua': 'Love Sales Light',
          'preprod-pl': 'mPromocje',
          'preprod-ua': 'Love Sales Light',
          'local': 'mPromocje',
          'pl': 'mPromocje',
          'ua': 'Love Sales Light'
        }
      },
      leaflet: 'Leaflet',
      pdfURL: 'Pdf url',
      imagesURLPattern: 'Link pattern',
      numberOfImages: 'Links amount',
      advanced: 'Advanced',
      lastPageInsert: 'Generate "Review" insert',
      adultsOnly: {
        label: 'Adults-only leaflet',
        hint: 'Adults-only leaflet is visible only in {platform}',
        hintNoPlatform: 'Adults-only leaflet is not visible on any platform',
        badge: 'Adults only 18+'
      },
      showOnlineBadge: 'Show online badge',
      showPopularBadge: 'Mark as ‘Popular’',
      addWatermark: 'Add watermark',
      previewFilesShow: 'Show {number} file previews',
      hideFilesShow: 'Hide {number} file previews',
      notAllowShoppingList: 'Turn shopping list off',
      notShowAdInserts: 'Turn advertising inserts off',
      forceLast: 'Put at the end of the list',
      redirectUrl: 'Redirect URL',
      additionalInfo: 'Information',
      additionalInfo2: 'Information 2',
      socialMedia: {
        label: 'Social Media',
        youtube: 'YouTube URL',
        youtubePlaceholder: 'https://www.youtube.com/watch?v=...',
        tiktok: 'TikTok URL',
        tiktokPlaceholder: 'https://www.tiktok.com/...',
        platform: 'Platform',
        url: 'URL',
        addNewLink: 'Add new link',
        remove: 'Remove',
        duplicateUrl: 'This URL is already added'
      },
      replaceValidity: {
        text: 'Replace validity text',
        isNull: 'No changes',
        isEmpty: 'Empty'
      },
      zipCodes: 'Zip codes',
      longUrl: 'URL',
      thumbnailTrackingUrl: 'Thumbnail tracking URL',
      status: {
        label: 'Status'
      },
      confirm: 'Create',
      success: 'Leaflet created successfully',
      multipleLeafletsSuccess: '{number} leaflets created successfully',
      multipleLeafletsFailure: 'Failed to create some of the leaflets',
      uploadingFiles: 'Uploading files...',
      generatingImages: 'Generating images...',
      generationTimeout: 'Image generation is taking too long',
      generationFailed: 'Failed to generate images',
      invalidTabs: 'Some tabs have invalid or missing data',
      error: 'Leaflet creation failed',
      update: 'Update',
      cancel: 'Cancel',
      invalidTab: 'Invalid',
      priorityLabels: {
        android: 'Android position',
        ios: 'IOS position',
        web: 'Web position',
        wp: 'WP position',
        android2: {
          'dev-1': 'mPromocje position',
          'preprod': 'mPromocje position',
          'preprod-pl': 'mPromocje position',
          'local': 'mPromocje position',
          'pl': 'mPromocje position',
          'ua': 'Love Sales Light position'
        }
      }
    },
    leafletsUpdate: {
      title: 'Update leaflet',
      success: 'Leaflet updated successfully',
      error: 'Leaflet update failed',
      button: 'Update',
      overwritePriority:
        'Position number {priorityNumber} is set for the leaflet with id: {leafletId}. Do you want to try overwrite this position?',
      overwritePriorities:
        'For {leafletsCount} platform(s) there already exists a leaflet with the position {priorityNumber}. Do you want to try to overwrite all conflicting priorities?',
      coverUpdated: 'Leaflet cover updated successfully'
    }
  },
  leafletPageDetails: {
    sharedDialogs: {
      pageCount: 'Page count: {numberOfPages}',
      cancel: 'Cancel',
      positionNumber: 'Position number',
      positionNumbers: 'Position numbers',
      description: 'Description',
      longUrl: 'Long URL',
      redirectUrl: 'Redirect URL',
      infoAlert:
        'The position numbers should be entered after a comma (eg. 1, 2, 3, 7) or a range should be given (eg. 5 - 12)',
      rules: {
        pageNumbersRequired: 'Position number is required',
        removeDuplicate: 'List consists duplicated positions',
        haveZero: 'Position should not be equal zero',
        allFieldsRequired: 'All fields are required',
        oneOfFieldsRequired: 'One of the fields must be completed',
        dateFromPast: 'Backdated link replacement cannot be scheduled',
        platformIsRequired: 'At least one platform have to be selected'
      }
    },
    insertDialog: {
      addTitle: 'Add insert to {naturalId}',
      editTitle: 'Update insert in {naturalId}',
      addConfirm: 'Add insert',
      editConfirm: 'Update insert',
      creationSuccess: 'Insert created successfully',
      updateSuccess: 'Insert overwritten succesfully',
      overrideConfirm: 'Insert already exists on that position. Do you want to overwrite it?',
      insertId: {
        label: 'Insert ID',
        placeholder: 'Pick insert from the list'
      },
      rules: {
        insertIdRequired: 'Insert is required',
        valueOutOfRange: 'Position number is bigger than leaflet pages count + 1'
      }
    },
    redirectDialog: {
      addTitle: 'Add redirect to {naturalId}',
      editTitle: 'Update redirect in {naturalId}',
      allPages: 'Add links to all pages',
      addConfirm: 'Add redirect',
      editConfirm: 'Update redirect',
      creationSuccess: 'Redirect created successfully',
      updateSuccess: 'Redirect updated successfully',
      schedule: {
        redirectUrl: 'Set redirect URL',
        thumbnailTrackingUrl: 'Set thumbnail tracking URL',
        longUrl: 'Set long URL',
        toDay: 'to',
        selectDay: 'select the day',
        atHour: 'at',
        selectHour: 'select the hour',
        changeTo: 'change to',
        typeNewLink: 'type new link'
      },
      scheduledEvents: {
        planningSuccess: 'Link swaps have been scheduled',
        redirectDeletionSuccess: 'Redirect link swap has been deleted.',
        longDeletionSuccess: 'Long link swap has been deleted.',
        thumbnailTrackingDeletionSuccess: 'Thumbnail tracking link swap has been deleted.',
        deleteLongButton: 'Delete scheduled long link swap',
        deleteRedirectButton: 'Delete scheduled redirect link swap'
      },
      overrideConfirm: 'Redirect already exists on that page. Do you want to overwrite it?',
      rules: {
        valueOutOfRange: 'Position number is bigger than leaflet pages count'
      }
    }
  },
  pageDetails: {
    fetchData: 'Loading page details..',
    description: 'Description',
    insertImageURL: 'Image URL',
    insertName: 'Name',
    pageNumber: 'Page number',
    positionNumber: 'Position number',
    redirectURL: 'Redirection URL',
    scheduledLinkReplacement: 'Scheduled link replacement',
    links: 'Links',
    date: 'Date',
    platforms: 'Platforms',
    longUrl: 'URL',
    actions: 'Actions',
    insertsFor: 'Inserts and redirects for leaflet:',
    showOnlineBadgeUpdate: {
      trueMsg: 'Leaflet checked as online',
      falseMsg: 'Deselected online status for the leaflet'
    },
    leafletLinks: {
      longUrl: 'Leaflet tracking URL',
      thumbnailTrackingUrl: 'Leaflet thumbnail tracking URL',
      edit: 'Edit',
      sync: 'Sync links',
      empty: '—',
      dialogTitle: 'Edit leaflet links',
      saveSuccess: 'Leaflet links saved successfully',
      saveError: 'Failed to save leaflet links'
    },
    inserts: 'Inserts',
    redirects: 'Redirects',
    removeInsert: {
      button: 'Remove',
      confirm: 'Do you really want to remove insert from this page',
      success: 'Redirect removed successfully'
    },
    removeRedirect: {
      button: 'Remove',
      confirm: 'Do you really want to remove links from this page?',
      success: 'Redirect removed successfully'
    },
    removeAllRedirects: {
      button: 'Delete all links',
      confirm: 'Do you really want to remove all links from this leaflet?',
      success: 'Links removed successfully.'
    },
    linkCreate: {
      button: 'Add links',
      title: 'Add links to '
    },
    bulkLinkCreate: {
      button: 'Bulk add links',
      title: 'Bulk add links to',
      dialog: {
        descriptionLabel: 'Description:',
        linksLabel: 'Links:',
        linksPlaceholder: 'Paste data from text editor here',
        addLinksBtn: 'Add links',
        cancelBtn: 'Cancel'
      }
    },
    insertUpdate: {
      button: 'Update'
    },
    insertCreate: {
      button: 'Add insert'
    },
    insertDeleteAll: {
      button: 'Delete all inserts',
      confirm: 'Are you sure you want to delete all leaflet inserts?',
      success: 'All inserts were successfully removed from the leaflet'
    },
    leafletArea: {
      areasDefinition: 'Define areas',
      page: 'Page: ',
      dimensions: 'Dimensions',
      areas: 'areas',
      link: 'Link',
      save: 'Save',
      promotedProduct: 'Promoted product',
      promoted: 'Promoted',
      pageArea: 'Page areas',
      deleteAll: 'Delete all',
      color: 'Color',
      actions: 'Actions',
      cancel: 'Cancel',
      deleteArea: {
        confirm: 'Do you really want to delete area?',
        successMsg: 'Area deleted successfully.'
      },
      deleteAllAreas: {
        confirm: 'Do you really want to delete ALL areas?',
        successMsg: 'All areas on {page} page deleted successfully.'
      },
      affiliation: {
        selectPlaceholder: 'No affiliation'
      },
      urlParameters: {
        label: 'Additional URL Parameters'
      },
      loadLinksFromPDF: {
        uploadButton: 'Load links from PDF file',
        uploadButtonPending: 'Loading links from PDF file...',
        successMsg: 'Links from file are loaded',
        errorMsg: 'Loading links has failed',
        progressMsg: 'Loading links from PDF is in progress...'
      },
      linkRequired: 'Link is required',
      linkInvalid: 'Link is invalid',
      areaInvalid: 'Selected area is invalid, should be at least 5 x 5 px'
    }
  },
  newLeafletsSearch: {
    notifications: {
      createDraft: {
        success: 'Draft leaflet created successfully',
        error: 'Error during draft leaflet creation'
      }
    },
    createDraftLeaflet: 'Create leaflet',
    selectStore: 'Select store',
    fetching: 'Loading data...',
    noStoreSelected: 'Please select a store to view leaflets',
    noStoreSelectedDescription: 'Choose a store from the dropdown above to see available leaflets',
    id: 'ID',
    status: 'Status',
    storeName: 'Store name',
    title: 'Title',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    numberOfPages: 'Number of pages',
    url: 'Identified by',
    attachments: 'Attachments',
    actions: 'Actions',
    updatedAt: 'Last updated',
    runCrawler: {
      button: 'Run crawler again',
      running: 'Crawling in progress',
      pending: 'Pending',
      queued: 'Queued for processing',
      processing: 'Processing',
      started: 'Started',
      retrying: 'Retrying',
      success: 'Crawling started successfully',
      error: 'Error during crawling'
    }
  },
  inserts: {
    fetchData: 'Loading inserts..',
    add: 'Add insert',
    description: 'Displayed description',
    redirectUrl: 'Redirect URL',
    longUrl: 'Long URL',
    showOn: 'Shown on',
    insertName: 'Name',
    insertImage: 'Image',
    actions: 'Actions',
    searchPlaceholder: 'Search inserts by name',
    showUsed: 'Show used inserts',
    clearSearch: 'Clear search',
    noData: 'No inserts',
    noDataFound: 'No inserts found by this search query',
    details: {
      deletion: {
        button: 'Remove insert from leaflet | Remove insert from leaflets',
        success: 'Insert has been removed from all leaflets',
        failed: 'Failed to remove insert from some leaflets. Please try again.'
      },
      removeAllLeafletsTitle: 'Remove all associations',
      removeAllLeafletsDescription: 'Are you sure you want to remove this insert from all leaflets it is assigned to?',
      empty: 'No leaflets to display',
      fetch: {
        error: {
          title: 'Error loading leaflets',
          description: 'Failed to fetch leaflet data. Please try again.'
        },
        partialError: {
          title: 'Some leaflets could not be loaded',
          description: 'Some leaflets failed to load, but others are displayed below.'
        }
      }
    },
    upload: {
      success: 'Insert uploaded successfully',
      failure: 'Insert upload failed'
    },
    update: {
      title: 'Update insert',
      button: 'Update',
      success: 'Insert updated successfully'
    },
    remove: {
      button: 'Remove',
      confirm: 'Do you really want to remove this insert?',
      success: 'Insert removed successfully',
      failure: 'Insert is used in leaflets:',
      blockedByUsage: 'This insert still has leaflet associations. Remove them before deleting the insert.'
    },
    archive: {
      button: 'Archive',
      confirm: 'Do you really want to archive this insert?',
      success: 'Insert archived successfully'
    },
    geolocation: {
      label: 'Geolocation',
      enabled: {
        description: 'Geolocated by areas',
        details: 'The insert will be visible according to the configured areas'
      },
      availableAreas: {
        label: 'Display locations (lat/lng/rad)',
        description:
          'The insert will be visible in these areas. Enter each address or area on a new line. Radius is given in meters.',
        placeholder: 'Warsaw\n51.4141,16.55551,100'
      },
      unavailableAreas: {
        label: 'Excluded locations (lat/lng/rad)',
        description:
          'The insert will not be visible in these areas. Enter each address or area on a new line. Radius is given in meters.',
        placeholder: 'Krakow\n50.0647,19.945,500'
      }
    },
    insertCreate: {
      title: 'Create insert',
      description: 'Displayed description',
      redirectUrl: 'Redirect URL',
      longUrl: 'Long URL',
      validDates: 'Valid dates',
      validFrom: {
        label: 'Valid from',
        placeholder: 'Select start date'
      },
      validTo: {
        label: 'Valid to',
        placeholder: 'Select end date'
      },
      insertName: 'Technical name',
      insertImageUrl: 'Image URL',
      showOnIOS: 'Show on iOS',
      showOnAndroid: 'Show on Android',
      showOnAndroid2: {
        'dev-1': 'Show on mPromocje',
        'dev-1-pl': 'Show on mPromocje',
        'preprod': 'Show on mPromocje',
        'preprod-pl': 'Show on mPromocje',
        'pl': 'Show on mPromocje',
        'ua': 'Show on Love Sales Light'
      },
      insertImage: 'Drop file here or click to upload insert photo',
      showOnWeb: 'Show on Web',
      confirm: 'Add',
      update: 'Update',
      cancel: 'Cancel',
      select: 'Select image',
      success: 'Insert created successfully'
    },
    rules: {
      name: 'Name is required',
      image: 'Image is required',
      existing: 'Insert with given name exists',
      geolocations: 'Each line must use the lat,lng,radius format. Convert addresses with the magic wand.',
      insertNameFormat:
        'Technical name can only contain letters, numbers, hyphens (-) and underscores (_). Spaces and other special characters are not allowed.'
    },
    usage: {
      title: 'Insert Usage Statistics',
      refresh: 'Refresh',
      noData: 'No insert usage data available',
      load: 'Load Data',
      totalInserts: 'Total Inserts Used',
      totalLeaflets: 'Total Leaflets with Inserts',
      lastUpdated: 'Last Updated',
      insertName: 'Insert Name',
      usageCount: 'Usage Count',
      actions: 'Actions',
      details: 'Details',
      leafletDetails: 'Leaflets using this insert',
      leafletId: 'Leaflet ID',
      storeId: 'Store ID',
      storeName: 'Store Name',
      validFrom: 'Valid From',
      validTo: 'Valid To',
      status: 'Status',
      view: 'View',
      used: 'Used',
      notUsed: 'Not used',
      more: 'more',
      showDetails: 'Show usage details',
      noLeaflets: 'No leaflets found for this insert',
      leafletNotFound: 'Leaflet not found'
    }
  },
  productHits: {
    boost: {
      title: 'Promote product',
      promote: 'Promote',
      cancel: 'Cancel promotion',
      position: 'Target position',
      until: 'Promotion ends',
      startsNow: 'Promotion starts immediately. Times use your browser’s local time zone.',
      validation: 'Enter a positive integer position and a future end date.',
      success: 'Product promoted',
      error: 'Could not change the promotion. Please try again.',
      conflict: 'This product already has a promotion. A ranking refresh has been requested.',
      forbidden: 'You do not have permission to manage promotions.',
      cancelConfirm: 'Cancel this promotion? The product will return to its organic ranking.',
      cancelSuccess: 'Promotion cancelled',
      notFound: 'This promotion no longer exists.',
      refreshError: 'Could not refresh the ranking. Retry to see the current positions.'
    },
    title: 'Product hits',
    promoted: 'Promoted',
    add: 'Add product',
    fetchData: 'Loading product hits...',
    table: {
      no: '#',
      trend: 'Trend',
      product: 'Product',
      priceBefore: 'Before',
      priceAfter: 'After',
      validity: 'Valid',
      promotion: 'Promotion',
      shop: 'Shop',
      actions: 'Actions'
    },
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      refresh: 'Refresh',
      deleteConfirmTitle: 'Delete product',
      deleteConfirmMessage: 'Are you sure you want to delete this product?',
      deleteSuccess: 'Product deleted',
      deleteError: 'Failed to delete product'
    },
    details: {
      title: 'Product details',
      name: 'Name',
      brand: 'Brand',
      trendIndex: 'Trend index',
      addedToShoppingList: 'Added to shopping list',
      mainInfo: 'Main info',
      position: 'Position',
      priceBefore: 'Before{currencySuffix}',
      priceAfter: 'After{currencySuffix}',
      promotion: 'Promotion',
      validity: 'Valid',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      shop: 'Shop',
      redirectUrl: 'Redirect URL',
      productFromLeaflet: 'Product from leaflet',
      editButton: 'Edit product',
      deleteButton: 'Delete product',
      positionEdit: {
        confirm: 'Confirm position',
        cancel: 'Cancel edit',
        success: 'Position updated',
        error: 'Failed to update position',
        validationError: 'Position must be an integer greater than or equal to 1'
      }
    },
    form: {
      title: 'Add product',
      editTitle: 'Edit product',
      label: 'Name',
      brand: 'Brand',
      tiValue: 'Trend index',
      crossedPrice: 'Price before',
      currentPrice: 'Price after',
      mainInfo: 'Main info',
      discount: 'Promotion',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      storeName: 'Store',
      redirectUrl: 'Redirect URL',
      isPromotedDescription: 'Promoted offer',
      isPromotedDetails: 'Should the product have a "Sponsored" badge',

      uploadProduct: 'Click or drop file to upload product image',
      uploadProductReplace: 'Click or drop file to replace product image',
      uploadStoreLogo: 'Click or drop file to upload store logo',
      uploadStoreLogoReplace: 'Click or drop file to replace store logo',
      productImagePreviewAlt: 'Product image preview',
      storeLogoPreviewAlt: 'Store logo preview',
      createSuccess: 'Product added',
      createError: 'Failed to add product',
      editSuccess: 'Product updated',
      editError: 'Failed to update product',
      rules: {
        label: 'Name is required',
        tiValue: 'Trend index is required',
        crossedPriceRequiresCurrentPrice: 'Price before requires price after',
        priceOrMainInfo: 'Enter the price after or main info',
        mainInfoMaxLength: 'Main info can have at most {max} characters',
        validFrom: 'Valid from is required',
        validTo: 'Valid to is required',
        productImage: 'Product image is required',
        storeName: 'Store name is required'
      }
    }
  },
  logs: {
    pickFile: 'Pick file',
    downloadFile: 'Download logs'
  },
  xmls: {
    pickDevice: 'Pick device type'
  },
  productCategories: {
    loading: 'Loading product categories...',
    loadError: 'Failed to load product categories.',
    code: 'Code',
    name: 'Name',
    sortOrder: 'Order',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    updatedAt: 'Last change',
    actions: 'Actions',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'Category activated.',
    deactivated: 'Category deactivated.',
    addCategory: 'Add category',
    addSubcategory: 'Add subcategory',
    edit: 'Edit',
    form: {
      createTitle: 'Add product category',
      codeImmutable: 'The code cannot be changed after the category is created.',
      parent: 'Parent',
      parentPlaceholder: 'None (root category)',
      sortOrderHint: 'Leave empty to place it last.',
      cancel: 'Cancel',
      create: 'Add',
      createSuccess: 'Product category added.',
      editTitle: 'Edit product category',
      save: 'Save',
      editSuccess: 'Product category saved.',
      renameConfirm: {
        title: 'Rename category?',
        message:
          'Offers and policies assigned to "{from}" will lose this category, because they reference categories by name. Rename to "{to}"?',
        confirm: 'Rename'
      },
      errors: {
        code: {
          required: 'Enter a code.',
          tooLong: 'The code can have at most 200 characters.',
          invalidFormat: 'Use lowercase letters, digits, ".", "_" and "-", starting with a letter or digit.'
        },
        name: {
          required: 'Enter a name.',
          tooLong: 'The name can have at most 255 characters.'
        }
      }
    },
    nameStatus: {
      inactive: 'inactive',
      unknown: 'unknown'
    },
    errors: {
      accessDenied: 'You do not have permission to access product categories.',
      hasChildren: 'This category has active subcategories. Deactivate its subcategories first.',
      codeAlreadyExists: 'A category with this code already exists.',
      nameAlreadyExists: 'A category with this name already exists under this parent.',
      invalidCode: 'The code is invalid.',
      parentNotFound: 'The parent category no longer exists. Refresh the page and try again.',
      cycle: 'A category cannot be moved under itself or its subcategory.',
      notFound: 'The category no longer exists. Refresh the page and try again.',
      unknown: 'Unexpected error. Try again later.'
    }
  },
  categories: {
    fetchData: 'Loading categories...',
    logo: 'Logo',
    id: 'ID',
    name: 'Name',
    categoryWebId: 'Id Name',
    update: {
      title: 'Update category',
      button: 'Update',
      success: 'Category updated successfully'
    },
    create: {
      title: 'Create category',
      button: 'Add category',
      success: 'Category created successfully'
    },
    rules: {
      name: 'Category name is required',
      categoryWebId: 'Id Name is required'
    },
    logoUpload: 'Drop file here or click to upload category logo',
    updateConfirm: 'Update',
    createConfirm: 'Add',
    cancel: 'Cancel',
    actions: 'Actions',
    remove: {
      button: 'Remove',
      confirm: 'Do you really want to remove this category?',
      success: 'Category removed successfully'
    }
  },
  archives: {
    inserts: {
      restore: 'Restore',
      restoreConfirm: 'Do you really want to restore this insert?',
      restoreSuccess: 'Insert restored successfully',
      restoreError: 'Error restoring insert',
      clearSearch: 'Clear search',
      noData: 'No inserts',
      noDataFound: 'No inserts found by this search query'
    },
    selectType: 'Select archives type you want to see',
    placeholder: 'Select',
    navButtons: {
      leaflets: 'Leaflets',
      shops: 'Stores',
      notifications: 'Notifications',
      leafletDetails: 'Leaflet details'
    },
    leaflets: {
      restore: 'Restore',
      viewDetails: 'View details',
      leafletsCount: 'leaflets',
      pickDate: 'Pick date',
      moreActions: 'More actions',
      expandFilters: 'Expand filters',
      collapseFilters: 'Collapse filters',
      filters: {
        title: 'Filters',
        storeName: 'Store name:',
        subtitle: 'Subtitle:',
        validDates: 'Valid dates:',
        searchButton: 'Search',
        clearButton: 'Clear',
        validFrom: 'Valid from:',
        validTo: 'Valid to:',
        sortBy: 'Sort by:',
        noData: 'No data to display',
        pressSearchButton: "Press 'Search' button to display data"
      },
      sortOptions: {
        id: 'Store id',
        name: 'Store name',
        category: 'Category',
        storeWebId: 'Store web id',
        logoUrl: 'Logo URL',
        showAnyway: 'Show anyway',
        storeAtFirst: 'Store at first',
        ascend: 'Ascending',
        descend: 'Descending',
        order: 'Order'
      },
      selectOptions: {
        true: 'True',
        false: 'False'
      }
    },
    notifications: {
      title: 'Notifications',
      expandFilters: 'Expand filters',
      collapseFilters: 'Collapse filters',
      filters: {
        title: 'Filters & Sorting'
      },
      tableLabels: {
        device: 'Device',
        id: 'Id',
        notificationId: 'Notification id',
        responseCode: 'Response code',
        sentAt: 'Sent at',
        stores: 'stores',
        channel: 'Channel',
        details: 'Details'
      },
      sortOptions: {
        device: 'Device',
        id: 'ID',
        notificationId: 'Notification id',
        responseCode: 'Response code',
        sentAt: 'Sent at date',
        stores: 'Stores'
      }
    },
    leafletDetails: {
      additionalInfo: 'Additional info: ',
      naturalId: 'Natural ID: ',
      seoId: 'SEO ID: ',
      status: 'Status: ',
      platforms: 'Publication platforms: ',
      validFrom: 'Valid from ',
      validTo: ' to ',
      publishDate: 'Publish date: ',
      createdAt: 'Created at: ',
      numberOfPages: 'Number of pages: ',
      showAdInserts: 'Show inserts: ',
      zipCode: 'Zip codes: ',
      longURL: 'URL: ',
      thumbnailTrackingUrl: 'Thumbnail tracking URL: ',
      redirectURL: 'Redirect URL: ',
      searchLabel: 'Insert leaflet natural ID',
      searchPlacecholder: 'Leaflet natural ID',
      closeCard: 'Close card',
      createdBy: 'Published by: ',
      activateReadyStatusAt: 'Refresh date: ',
      refreshedBy: 'Refreshed by: '
    },
    leafletUpdateHistory: {
      title: 'Edition history',
      leafletHistoryTab: 'Leaflet history',
      pageDetailsHistoryTab: 'Inserts history',
      redirectsHistoryTab: 'Redirects history',
      description: 'Description',
      actionType: 'Action type',
      field: 'Field',
      oldValue: 'Previous value',
      newValue: 'New value',
      pageNumber: 'Position number',
      visibleAt: 'Visible at',
      insertName: 'Name',
      modifiedBy: 'Edited by',
      modifiedAt: 'Edited at',
      added: 'Added',
      deleted: 'Deleted',
      redirects: {
        description: 'Description',
        pageNumber: 'Page number',
        redirectURL: 'Redirect URL',
        longURL: 'Long URL'
      },
      android: 'Android',
      ios: 'IOS',
      longUrlVisibleAt: 'Long URL for',
      redirectUrl: 'Redirect URL',
      longUrl: 'Long URL',
      previousValue: 'Previous value: '
    },
    shops: {
      noArchivedShops: 'No archived shops found',
      archived: 'Archived'
    },
    restore: {
      title: 'Confirm Restore',
      button: 'Restore',
      confirm: 'Do you really want to restore this shop?',
      success: 'Shop restored successfully'
    }
  },
  showHttpWarning: 'New versions of iOS and Android cannot open links without SSL!',
  cooksAndRecipes: {
    recipeTable: {
      title: 'Title',
      type: 'Type',
      visibleAt: 'Visible at',
      status: {
        label: 'Status'
      },
      actions: {
        label: 'Actions',
        edit: 'Edit',
        preview: 'Recipe preview',
        delete: 'Delete'
      }
    },
    addCookDialog: {
      title: 'Add new cook',
      availableEditors: 'Available editors',
      assignedEditors: 'Assigned editors',
      labels: {
        name: 'Cook name',
        id: 'Name id',
        logoUpload: 'Drop file here or click to upload cook logo'
      },
      success: {
        create: 'Cook {name} created successfully.',
        update: 'Cook {name} updated successfully.'
      },
      placeholders: {
        name: 'Insert cook name'
      },
      rules: {
        requiredName: 'Cook name is required',
        required: 'This field is required',
        seoIdRule: 'Name Id can only contain lowercase letters, numbers and "-" sign',
        cookNameTaken: 'Cook with the given name already exists.'
      },
      statusList: {
        INACTIVE: 'Inactive',
        READY_FOR_ACTIVATION: 'Ready for activation',
        READY_FOR_DISACTIVATION: 'Ready for disactivation',
        ACTIVE: 'Active'
      },
      footerButtons: {
        cancel: 'Cancel',
        create: 'Add cook',
        update: 'Save changes'
      }
    },
    addRecipeDialog: {
      recipePages: 'Recipe pages',
      footerButtons: {
        create: 'Add recipe'
      },
      addStep: 'Add step',
      rules: {
        required: 'This field is required',
        onlyNumbers: 'Please insert a proper value',
        invalidShoppingListUrl:
          'Shopping list url is invalid. It should match pattern:\nhttps://mojagazetka.com/lista/shopping-list-ID',
        isFromRecipe: 'List from recipe (isFromRecipe: true)'
      },
      success: {
        create: 'Recipe created successfully.',
        update: 'Recipe updated successfully.'
      },
      title: 'Add new recipe',
      editTitle: 'Edit recipe',
      labels: {
        logoUpload: 'Drop file here or click to upload recipe cover',
        recipeCreatedWith: 'Recipe created in cooperation with',
        leafletId: 'Leaflet ID',
        seoId: 'ID',
        publishDate: 'Publish date',
        stepImageUpload: 'Drop file here or click to upload recipe step image',
        status: 'Status',
        title: 'Title',
        preparationTime: 'Preparation time',
        complexity: 'Complexity of execution',
        tags: 'Tags',
        longUrl: 'Long URL',
        shoppingListUrl: 'Shopping list URL',
        shoppingList: 'Shopping list',
        visibleAt: 'Visible at',
        numberOfServings: 'Number of servings'
      },
      placeholders: {
        shoppingListUrl: 'Add a link to the shopping list that was created on the mobile phone',
        shoppingList: 'The shopping list will be displayed here',
        loading: 'Loading shopping list...',
        missingShoppingListProducts: 'Shopping list is empty or has incorrect ID',
        complexity: 'Choose the complexity level',
        leafletId: 'Enter leaflet UUID',
        tags: 'Enter tags, separating them with a comma',
        title: 'Insert recipe title',
        preparationTime: 'Enter preparation time in minutes',
        cooperatedWith: 'Select a store',
        stepName: 'Step name',
        description: 'Description',
        extraDescription: 'Extra description'
      },
      complexity: {
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard'
      }
    },
    recipes: {
      publish: {
        button: 'Publish recipes',
        confirm: 'Do you really want to publish recipes?',
        success: 'Recipes published successfully.'
      },
      showAll: 'Expand all recipes',
      hideAll: 'Shrink all recipes',
      delete: {
        confirm: 'Do you really want to delete this recipe?',
        success: 'The recipe was successfully removed.'
      }
    },
    cooks: {
      addRecipe: 'Add recipe',
      editCook: 'Edit cook',
      deleteCook: 'Delete cook',
      addCook: 'Add cook',
      delete: {
        confirm: 'Do you really want to delete cook: {cook}?',
        success: 'Cook {cook} deleted successfully.'
      },
      collapseRecipes: 'Shrink recipes',
      expandRecipes: 'Expand recipes',
      fetching: 'Loading cooks...',
      noCooks: 'No cooks to display!',
      noCooksDetails: 'Add the first cook to view his details.'
    },
    recipePreview: {
      title: 'Recipe preview',
      noImage: 'No image',
      preparationMinutes: 'Minutes',
      portionFor: 'For {number} people',
      complexity: {
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard'
      },
      summarizeHeader: 'Done? Enjoy your meal!',
      summarizeText: 'Add a dish to the Cooked to always have it within reach.'
    }
  },
  scrapper: {
    tabs: {
      zipTabName: 'ZIP file',
      pdfTabName: 'Generate pdf link'
    },
    pdf: {
      urlInputPlaceholder: 'URL to .pdf',
      downloadButtonLabel: 'Generate .pdf link',
      copyLink: 'Copy link to the clipboard',
      linkToFile: 'Link to file:',
      copySuccess: 'Link to .pdf copied to the clipboard',
      copyError: 'Copying link to .pdf failed'
    },
    zip: {
      urlInputPlaceholder: 'Leaflet URL',
      urlInputPrefixPlaceholder: 'Leaflet Prefix',
      downloadButtonLabel: 'Download',
      ifDownloadDidntStart: "If downloading didn't start automatically",
      clickHere: 'click here'
    }
  },
  reels: {
    urlCopiedToClipboard: {
      success: 'Link copied',
      error: 'Link has been not copied'
    },
    header: {
      title: 'Channels ({reelsChannelsCount})',
      buttons: {
        addChannel: 'Add new channel'
      },
      showExpiredReels: 'Show expired reels'
    },
    addChannel: {
      title: 'Add reels channel',
      form: {
        logo: 'Drop file here or click to upload channel logo',
        naturalId: 'Natural ID',
        name: 'Name',
        description: 'Description',
        positionIndex: 'Fixed position',
        positionIndexPlaceholder: 'Leave empty for default sorting',
        clearPosition: 'Clear position',
        tracking: {
          title: 'Tracking',
          trackingUrlView: 'View',
          trackingUrlViewPlaceholder: 'Enter tracking URL for views',
          trackingUrlClick: 'Click',
          trackingUrlClickPlaceholder: 'Enter tracking URL for clicks'
        },
        autoCreateReels: {
          description: 'Generate reels automatically',
          details: 'When checked, new reels will be generated automatically based on the added leaflets'
        },
        buttons: {
          create: 'Add channel',
          cancel: 'Cancel'
        },
        validations: {
          naturalId: 'Natural ID is required',
          name: 'Channel name is required',
          positionIndex: 'Position must be a non-negative integer',
          trackingUrl: 'Tracking URL must start with http:// or https://',
          trackingUrlLength: 'Tracking URL cannot exceed 255 characters'
        }
      },
      success: 'Channel has been successfully added',
      errors: {
        positionIndexDuplicated: 'A channel with this position already exists for this country',
        positionIndexNegative: 'Position index cannot be negative',
        generic: 'An error occurred while saving the channel'
      }
    },
    editChannel: {
      title: 'Edit {channelName} channel',
      form: {
        buttons: {
          update: 'Update'
        }
      },
      success: 'Channel has been successfully updated'
    },
    addReel: {
      title: 'Add new reel',
      form: {
        logo: 'Click or drop to add file',
        mediaURL: 'Media URL',
        naturalId: 'Natural ID',
        shortDescription: 'Description',
        ctaButtonText: {
          label: 'CTA',
          placeholder: 'Insert button text'
        },
        visibilityTime: {
          label: 'Visibility time',
          suffix: 'seconds | second | seconds'
        },
        status: {
          label: 'Status',
          options: {
            draft: 'Draft',
            deactivated: 'Deactivated',
            published: 'Published'
          }
        },
        visibilityStartDate: {
          label: 'From',
          placeholder: 'Select date and time'
        },
        visibilityEndDate: {
          label: 'To',
          placeholder: 'Select date and time'
        },
        publishDate: {
          label: 'Publish date',
          placeholder: 'Select date and time'
        },
        mediaType: {
          label: 'Media type'
        },
        internalNote: {
          label: 'Note',
          placeholder: 'Insert technical note'
        },
        showOn: 'Show on',
        tracking: {
          title: 'Tracking',
          impressionsTracking: 'Displays',
          clicksTracking: 'Clicks'
        },
        buttons: {
          create: 'Save and publish',
          createDraft: 'Save draft reel',
          cancel: 'Cancel'
        },
        actionType: {
          label: 'Action type',
          leafletRedirect: {
            label: 'Leaflet redirect',
            insertNumber: 'Insert number',
            standardPageNumber: 'Page number',
            leafletId: 'Leaflet ID',
            leafletIdPlaceholder: 'Search by leaflet ID, store name, or title...'
          },
          externalRedirect: {
            label: 'External redirect',
            url: 'URL'
          },
          shoppingListAdd: {
            label: 'Shopping list',
            productName: 'Product name'
          }
        },
        validations: {
          naturalId: 'Natural ID is required',
          file: 'Reel file is required',
          visibilityTime: 'Visibility time is required',
          status: 'Reel status is required',
          visibilityStartDate: 'Visibility start date is required',
          visibilityEndDate: {
            required: 'Visibility end date is required',
            dateFromThePast: 'Date is from the past',
            datePreviousThanStartDate: 'Visibility end date is before visibility start date'
          },
          publishDate: 'Publish date is required',
          mediaType: 'Reel type is required',
          action: {
            leafletId: 'Leaflet ID is required',
            leafletIdFormat:
              'Leaflet ID must follow format: storeName-dd-mm-yy-dd-mm-yy-abcde (e.g., biedronka-16-07-25-22-07-25-nckyx)',
            standardPageNumber: 'Standard page number is required',
            url: 'Redirect URL is required',
            productName: 'Product name is required'
          }
        }
      },
      success: 'Reel has been added'
    },
    editReel: {
      title: 'Edit reel',
      form: {
        buttons: {
          update: 'Update',
          createDraft: 'Update draft reel'
        }
      },
      success: 'Reel has been successfully updated'
    },
    publishReel: {
      confirm: 'Are you sure you want to publish this reel?',
      success: 'Reel has been published',
      button: 'Publish reel'
    },
    deactivateReel: {
      confirm: 'Are you sure you want to deactivate this reel?',
      success: 'Reel has been deactivated',
      button: 'Deactivate reel'
    },
    removeReel: {
      confirm: 'Are you sure you want to remove this reel?',
      success: 'Reel has been removed',
      button: 'Remove reel'
    },
    channel: {
      empty: 'No channels to display',
      cardHeader: {
        imageAlt: 'Channel logo',
        active: 'Active: {activeReelsCount}',
        archived: 'Archived: {archivedReelsCount}',
        addReels: 'Add Reel',
        moreOptions: {
          edit: 'Edit',
          remove: 'Remove channel'
        }
      },
      noReels: 'No reels to display',
      delete: {
        confirm: 'Do you really want to delete {channelName} channel?',
        success: 'Channel has been removed',
        button: 'Remove'
      },
      positionFixed: 'Position: {position}'
    },
    basicReelData: {
      id: 'ID',
      naturalId: 'Natural ID',
      description: 'Description',
      visibilityTime: 'Visibility time',
      type: 'Type',
      cta: 'CTA',
      mediaType: 'Media type',
      validFor: 'Valid for',
      expired: 'This reel has expired',
      moreOptions: {
        edit: 'Edit',
        publish: 'Publish',
        deactivate: 'Deactivate'
      }
    },
    advancedReelData: {
      hideDetails: 'Hide details',
      showDetails: 'Show details',
      createdAt: 'Created at',
      lastEditedAt: 'Last edited at',
      interactionMadeBy: '{date} by {user}',
      visibleOn: 'Show on',
      trackingUrlDisplayCount: 'Displays (tracking link)',
      trackingUrlClickCount: 'Clicks (tracking link)',
      note: 'Note',
      leafletId: 'Leaflet ID',
      standardPageNumber: 'Page number',
      insertNumber: 'Insert number',
      link: 'Link',
      placeholders: {
        noShortDescription: '/no description/',
        noCtaButton: '/no content/',
        noAvailablePlatforms: '/no platforms/',
        noLink: '/no link/',
        noNote: '/no note/',
        noEdit: '/no edition/'
      }
    }
  },
  components: {
    leafletSeoIdInput: {
      placeholder: 'Search by leaflet seoId, store name, or title...'
    }
  },
  slider: {
    title: 'Slider',
    addSlide: 'Add new slide',
    editSlide: 'Edit slide',
    deleteSlide: 'Delete slide',
    activeCount: 'Active: {count}',
    inactiveCount: 'Inactive: {count}',
    noSlides: 'No slides to display',
    errorFetching: 'Error loading slides',
    errorCreating: 'Error creating slide',
    errorUpdating: 'Error updating slide',
    errorDeleting: 'Error deleting slide',
    errorReordering: 'Error reordering slide',
    createSuccess: 'Slide created successfully',
    updateSuccess: 'Slide updated successfully',
    deleteSuccess: 'Slide deleted successfully',
    deleteConfirm: 'Are you sure you want to delete this slide?',
    deleteDialog: {
      title: 'Delete Slide',
      message: 'What would you like to do with this slide?',
      delete: 'Delete permanently',
      markAsDraft: 'Mark as draft',
      cancel: 'Cancel'
    },
    markAsDraftSuccess: 'Slide marked as draft successfully',
    form: {
      title: 'Add slide',
      editTitle: 'Edit slide',
      slideType: {
        label: 'Slide Type',
        placeholder: 'Select slide type',
        image: 'Image',
        gif: 'GIF'
      },
      uploadImage: 'Click or drop file to add',
      uploadGif: 'Click or drop GIF file to add',
      description: {
        label: 'Description',
        placeholder: 'Enter slide description'
      },
      name: {
        label: 'Title',
        placeholder: 'Enter slide title'
      },
      redirect: {
        label: 'Redirect URL',
        placeholder: 'Enter redirect URL'
      },
      linkType: {
        label: 'Link type',
        external: 'External URL',
        leaflet: 'Leaflet'
      },
      leafletRedirect: {
        leafletId: 'Leaflet ID',
        leafletIdPlaceholder: 'Search by leaflet ID, store name, or title...',
        standardPageNumber: 'Page number',
        insertNumber: 'Insert number'
      },
      position: {
        label: 'Position',
        placeholder: 'Enter position'
      },
      status: {
        label: 'Status',
        placeholder: 'Select status'
      },
      validityPeriod: 'Validity Period',
      validFrom: {
        label: 'From',
        placeholder: 'Select date and time'
      },
      validTo: {
        label: 'To',
        placeholder: 'Select date and time'
      },
      publishedAt: {
        label: 'Publication',
        placeholder: 'Select date and time'
      },
      note: {
        label: 'Note',
        placeholder: 'Add note'
      },
      showOn: 'Show on:',
      tracking: {
        title: 'Tracking',
        views: 'Views',
        clicks: 'Clicks',
        trackingUrlView: {
          label: 'View',
          placeholder: 'Enter tracking URL for views'
        },
        trackingUrlClick: {
          label: 'Click',
          placeholder: 'Enter tracking URL for clicks'
        }
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save'
      },
      uploadLimit: 'Only one file can be uploaded'
    },
    rules: {
      imageRequired: 'Image is required',
      gifRequired: 'GIF file is required',
      nameRequired: 'Title is required',
      statusRequired: 'Status is required',
      validFromRequired: 'Start date is required',
      redirectUrlInvalid: 'Invalid URL format',
      leafletIdRequired: 'Leaflet ID is required',
      leafletIdInvalid:
        'Leaflet ID must match the format: storeName-dd-mm-yy-dd-mm-yy-abcde (for example biedronka-16-07-25-22-07-25-nckyx)',
      standardPageNumberRequired: 'Page number is required',
      leafletPageTargetRequired: 'Set either page number or insert number',
      positionInvalid: 'Position must be a number greater than or equal to 0'
    },
    table: {
      name: 'Name',
      redirect: 'Redirect',
      trackingUrl: 'Tracking URL',
      added: 'Added',
      updated: 'Updated',
      position: 'Position',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      visibility: 'Visibility',
      status: 'Status',
      actions: 'Actions',
      noData: 'No data',
      pageNumber: 'page',
      insertNumber: 'insert',
      none: 'none'
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      draft: 'Draft'
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
      mpromocje: 'mPromocje'
    },
    aspectRatio: {
      '16x9': '16:9',
      '4x3': '4:3',
      '1x1': '1:1'
    },
    filters: {
      title: 'Filters',
      clear: 'Clear',
      clearAll: 'Clear all filters',
      apply: 'Apply',
      showActive: 'Show active sliders',
      showVisibleNow: 'Visible to clients',
      visibleNow: 'Visible to clients',
      activeFilters: 'Active filters',
      platform: {
        title: 'Filter by platform'
      },
      status: {
        title: 'Filter by status',
        all: 'All',
        active: 'Active',
        draft: 'Draft',
        expired: 'Expired'
      }
    },
    sorting: {
      sortBy: 'Sort by',
      ascending: 'Ascending',
      descending: 'Descending'
    }
  },
  tradeDays: {
    title: 'Trade Days',
    status: 'Status',
    statusList: {
      STORES_CLOSED: 'Stores Closed',
      STORES_OPENED: 'Stores Opened',
      CUSTOM: 'Custom',
      NOT_APPLICABLE: 'Not Applicable'
    },
    months: {
      0: 'January',
      1: 'February',
      2: 'March',
      3: 'April',
      4: 'May',
      5: 'June',
      6: 'July',
      7: 'August',
      8: 'September',
      9: 'October',
      10: 'November',
      11: 'December'
    },
    weekDays: {
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
      Sun: 'Sun'
    },
    modal: {
      createTitle: 'Create Trade Day',
      editTitle: 'Edit Trade Day'
    },
    form: {
      date: 'Date',
      selectDate: 'Select date',
      status: 'Status',
      localizedFields: 'Localized Fields',
      title: 'Title',
      titlePlaceholder: 'Enter title',
      tip: 'Tip',
      tipPlaceholder: 'Enter tip',
      customDescription: 'Custom Description',
      customDescriptionPlaceholder: 'Enter custom description',
      copyFromDay: 'Copy from another day',
      copyFromDayDescription: 'Copy values from an existing trade day to fill empty fields'
    },
    copyDialog: {
      title: 'Copy from Another Day',
      selectYear: 'Select Year',
      selectDate: 'Select a date to copy from',
      preview: 'Preview',
      noDataForYear: 'No trade days found for {year}',
      noDaysAvailable: 'No trade days available to copy from',
      copyButton: 'Copy to Current Form',
      cancel: 'Cancel',
      emptyField: 'Not set',
      previewDate: 'Date',
      previewStatus: 'Status',
      previewTitles: 'Titles',
      previewTips: 'Tips',
      previewDescriptions: 'Descriptions'
    },
    validation: {
      dayDateRequired: 'Date is required',
      dayStatusRequired: 'Status is required',
      dayStatusInvalid: 'Invalid status value',
      maxLength: 'Maximum length is {max} characters',
      fieldMaxLength: '{field} exceeds maximum length of {max} characters'
    },
    messages: {
      createSuccess: 'Trade day created successfully',
      updateSuccess: 'Trade day updated successfully',
      deleteSuccess: 'Trade day deleted successfully',
      copySuccess: 'Values copied from {date}',
      copyOnlyEmptyFields: 'Only empty fields were filled'
    },
    errors: {
      fetchFailed: 'Failed to load trade days',
      createFailed: 'Failed to create trade day',
      updateFailed: 'Failed to update trade day',
      deleteFailed: 'Failed to delete trade day'
    },
    deleteConfirm: {
      title: 'Delete Trade Day',
      message: 'Are you sure you want to delete this trade day? This action cannot be undone.'
    },
    bulkUpdate: {
      buttonLabel: 'Bulk Update',
      daysOfWeek: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      },
      form: {
        dayOfWeek: 'Day of Week',
        selectDayOfWeek: 'Select day of week',
        dateRange: 'Date Range',
        entireYear: 'Entire Year',
        customRange: 'Custom Range',
        year: 'Year',
        customDateRange: 'Custom Date Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        tradeDaySettings: 'Trade Day Settings'
      },
      dialog: {
        title: 'Bulk Update Trade Days',
        titleConfigure: 'Bulk Update - Configure',
        titlePreview: 'Bulk Update - Preview',
        titleConfirm: 'Bulk Update - Confirm',
        cancel: 'Cancel',
        previewDates: 'Preview Dates',
        back: 'Back',
        proceedToConfirm: 'Proceed to Confirm'
      },
      preview: {
        summary: 'Summary',
        totalAffected: 'Total Dates Affected',
        newEntries: 'New Entries',
        overwrites: 'Overwrites',
        affectedDates: 'Affected Dates',
        new: 'New',
        willOverwrite: 'Will Overwrite',
        showAllDates: 'Show All {count} Dates',
        showLess: 'Show Less',
        overwriteWarning: 'Overwrite Warning',
        overwriteWarningMessage: '{count} existing trade day(s) will be overwritten with new values.',
        infoTitle: 'Review Before Proceeding',
        infoMessage:
          'Please review the affected dates carefully. In the next step, you will need to confirm this action.'
      },
      confirmation: {
        title: 'Confirm Bulk Update',
        warningTitle: 'Warning: This Action Cannot Be Undone',
        warningMessage: 'You are about to perform a bulk update operation:',
        totalDates: 'Total dates to be affected: {count}',
        overwriteCount: '{count} existing trade day(s) will be overwritten',
        cannotUndo: 'This action cannot be undone',
        summaryTitle: 'Operation Summary',
        typeToConfirm: 'Type "{text}" to confirm:',
        confirmationMismatch: 'Please type CONFIRM exactly as shown above',
        cancel: 'Cancel',
        confirmButton: 'Confirm and Execute'
      },
      validation: {
        dayOfWeekRequired: 'Day of week is required',
        yearRequired: 'Year is required',
        fromDateRequired: 'Start date is required',
        toDateRequired: 'End date is required',
        toDateBeforeFromDate: 'End date must be after start date',
        noMatchingDates: 'No dates match the selected criteria'
      },
      messages: {
        successCount: '{count} trade day(s) updated successfully',
        failureCount: '{count} trade day(s) failed to update'
      }
    }
  },
  marketingFileUpload: {
    dropZoneText: 'Drag files here or click to browse',
    dropZoneHint: 'Accepted: {extensions}',
    filesReady: '{count} file(s) ready',
    totalSize: '{size} total',
    clearAll: 'Clear all',
    upload: 'Upload {count} file(s)',
    cancel: 'Cancel',
    currentFile: 'Current file',
    removeFile: 'Remove {name}',
    confirmTitle: 'Confirm upload',
    confirmMessage: 'Upload {count} files ({size}) to campaign "{campaign}"?',
    uploadSuccess: 'File uploaded successfully | {count} files uploaded successfully',
    uploadError: 'Error uploading file',
    partialSuccess: '{success} of {total} files uploaded. {failed} failed.',
    validationErrors: {
      invalidType: 'File type "{ext}" is not allowed',
      fileTooLarge: 'File size {size} exceeds maximum {max}',
      maxFilesExceeded: 'Maximum {max} files allowed'
    }
  },
  hotkeys: {
    title: 'Keyboard Shortcuts',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    newArticle: 'New article',
    editHoveredArticle: 'Edit hovered article',
    editArticleArea: 'Redraw article area',
    closeDialog: 'Close dialog',
    saveArticle: 'Save article',
    cancelEditing: 'Cancel editing',
    showHelp: 'Show keyboard shortcuts',
    dashboard: {
      moveDown: 'Move focus down',
      moveUp: 'Move focus up',
      enterLeaflets: 'Enter leaflet list',
      exitLeaflets: 'Exit leaflet list',
      clearFocus: 'Clear focus',
      focusSearch: 'Focus search',
      primaryAction: 'Toggle list / Edit leaflet',
      addLeaflet: 'Add leaflet',
      editStore: 'Edit store',
      delete: 'Delete focused item',
      activateAllLeaflets: 'Activate all leaflets',
      goToPageDetails: 'Go to redirects and inserts',
      openPageDetailsImages: 'Open page images',
      openArticlesData: 'Open articles data',
      syncLongUrl: 'Sync long URL',
      copySeoId: 'Copy SEO ID'
    },
    menuNavigation: 'Open menu navigation',
    menuNav: {
      hintRoot: 'Press letter to navigate',
      hintEsc: 'Esc to cancel',
      hintBack: 'Esc to go back',
      back: 'Back'
    }
  }
}
